if (typeof RaysLotteryRG === 'undefined') {


    const RaysLotteryRG = class {
        constructor() {
            if (RaysLotteryRG.instance) {
                return RaysLotteryRG.instance;
            }
            // Token 相关配置
            const APP_ENV = window.renogyConfig.mode;
            this.ACCESS_TOKEN_KEY = `renogy_account_access_token_key_${APP_ENV}_1.0`;
            this.REFRESH_TOKEN_KEY = `renogy_account_refresh_token_key_${APP_ENV}_1.0`;
            
            this.accessToken = this.getCookie(this.ACCESS_TOKEN_KEY);
            this.refreshToken = this.getCookie(this.REFRESH_TOKEN_KEY);
            this.userInfo = null;
            this.merberData = null;
            this.subscribeEmailInfo = null;
            this.pageCouponTemplateData = null;
            this.giftCardCouponData = null;
            this.productCardCouponData = null;
            this.exchangeResult = null;
            this.exchangeGiftCardResult = null;
            this.API_DOMAIN = window.renogyConfig.apiUrl;
            this.storeId = window.renogyConfig?.storeId || '1';
            // 2025-bfcm-rays
            this.tagName = null;
            this.customerEmail = window.raysLotteryBlocksData.settings.customer_email;
            this.customerPoints = null;
            this.noLogin = true;
            this.playBtn = null;
            this.allOutOfStock = false;
            this.storeName = this.getSite().site;
            this.apiUrl = this.getSite().apiUrl;
            this.raysLotteryUserList = [];
            this.startTimeWrapper = null ;
            this.endTimeWrapper = null ;
            this.headSubtitle = null;
            this.closeBtnHtml = `<svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 26 26" fill="none">
                <rect x="1" y="1" width="24" height="24" rx="12" fill="white" fill-opacity="0.3"/>
                <rect x="6.33295" y="18.4546" width="17.1429" height="1.71429" rx="0.857143" transform="rotate(-45 6.33295 18.4546)" fill="#1C1C1C"/>
                <rect x="18.4548" y="19.667" width="17.1429" height="1.71429" rx="0.857143" transform="rotate(-135 18.4548 19.667)" fill="#1C1C1C"/>
            </svg>`
            this.toastErrorIcon = `<svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28" fill="none">
                <rect x="5" y="5" width="18" height="18" rx="9" stroke="#E04700" stroke-width="2"/>
                <circle cx="14" cy="10.1992" r="1" fill="#E04700"/>
                <rect x="13" y="12" width="2" height="6.8" rx="1" fill="#E04700"/>
            </svg>`
            this.toastTipsIcon = `<svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28" fill="none">
            <rect x="6" y="8" width="16" height="16" rx="8" stroke="#00C0FF" stroke-width="2" stroke-linecap="round"/>
            <path d="M14 12V15.6C14 15.8209 14.1791 16 14.4 16H18" stroke="#00C0FF" stroke-width="2" stroke-linecap="round"/>
            <line x1="12" y1="5" x2="16" y2="5" stroke="#00C0FF" stroke-width="2" stroke-linecap="round"/>
            <path d="M15 7.29961L13 7.29961L13 4.59961L15 4.59961L15 7.29961Z" fill="#00C0FF"/>
            <line x1="20" y1="9.58579" x2="20.99" y2="8.59584" stroke="#00C0FF" stroke-width="2" stroke-linecap="round"/>
            </svg>`;
            this.toastIconNoPoints = `<svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28" fill="none">
            <path d="M22 14C22 9.58172 18.4183 6 14 6C9.58172 6 6 9.58172 6 14C6 18.4183 9.58172 22 14 22V24C8.47715 24 4 19.5228 4 14C4 8.47715 8.47715 4 14 4C19.5228 4 24 8.47715 24 14C24 19.5228 19.5228 24 14 24V22C18.4183 22 22 18.4183 22 14Z" fill="#00C0FF"/>
            <path d="M12.957 8.7743C13.5093 8.15336 14.4906 8.15336 15.0429 8.7743L15.1553 8.91688L16.3867 10.7147L18.4785 11.3319C19.4217 11.6102 19.7919 12.7487 19.1924 13.5282L17.8623 15.2557L17.9228 17.4354C17.9496 18.4185 16.9804 19.1224 16.0537 18.7929L14 18.0624L11.9463 18.7929C11.0196 19.1224 10.0504 18.4185 10.0771 17.4354L10.1367 15.2557L8.8076 13.5282C8.20804 12.7487 8.57829 11.6102 9.52146 11.3319L11.6123 10.7147L12.8447 8.91688L12.957 8.7743ZM13.1416 12.0214C12.9595 12.287 12.6917 12.4821 12.3828 12.5731L10.9267 13.0018L11.8525 14.205C12.0489 14.4602 12.1514 14.7757 12.1426 15.0975L12.1006 16.6141L13.5312 16.1063L13.6455 16.0712C13.8779 16.0103 14.1221 16.0103 14.3545 16.0712L14.4687 16.1063L15.8984 16.6141L15.8574 15.0975C15.8486 14.7757 15.9511 14.4602 16.1474 14.205L17.0722 13.0018L15.6172 12.5731C15.3083 12.4821 15.0404 12.287 14.8584 12.0214L14 10.7694L13.1416 12.0214Z" fill="#00C0FF"/>
            </svg>`;
            this.prizeData = window.lotteryBlocksData || null;

            // Token 刷新相关变量
            this.isRefreshing = false;
            this.refreshPromise = null;
            this.pendingRequests = [];

            // TODOLIST: 事件监听器标志位，防止重复添加
            this.eventListenersInitialized = false;
            this.copyButtonListenerAdded = false;
            this.visibilityChangeListenerAdded = false;

            this.raysLotteryRGContainer = document.querySelector('[data-rays-lottery-rg-container]');
            this.activity = this.raysLotteryRGContainer?.dataset?.activity || null;
            // for test
            if(window.location.hostname === '127.0.0.1') {
                this.apiUrl = 'https://d79a56e0d9be.ngrok-free.app';
                this.customerEmail = this.customerEmail ? this.customerEmail : '';
                this.accessToken = 'eyJhbGciOiJIUzUxMiJ9.eyJpZCI6OTAxNzQ2LCJlbWFpbCI6IjE0NDIxMjM1MTBAcXEuY29tIiwic3VwcG9ydF9yZWZyZXNoIjp0cnVlLCJqdGkiOiJaVEkzT1dZd1pUa3RNamRtWWkwMFpUSmxMVGt5WlRRdFpUSTVZMlEwTkRNMllUZGsiLCJpYXQiOjE3NjI0OTk4NjYsImV4cCI6MTc2MjU4NjI2Nn0.jt8GG85e4RveNNywOa2Jq4hmHyRR7HbmquSTFiIB8WRg9WKAzvPJkKcKl6nhvr_ph250vR0EIvpVkxZWHZwH2g'
                this.refreshToken ='eyJhbGciOiJIUzUxMiJ9.eyJpZCI6OTAxNzQ2LCJpYXQiOjE3NjI0OTk4NjYsImp0aSI6Ik5UVmhNemd5Tm1VdFlqUXlPUzAwWVRVMUxXSXpNbVl0TnpZNU4ySmlaakkxWVdNeCJ9.VNICUryilxL-yrilBwghGDXq4gVMw3twTQUIxbrAYJPhdWh0kFhWrzLd7YykEESOy6D8dbuKjXapTHoNpLwnlA'
            }


            // 多语言文本配置
            this.enMessages = {
                couponInfo: {
                    out_of_stock: 'Out Of Stock',
                    coupon_text:"Available Over",
                    available: 'Available',
                    usage_rules: 'Usage Rules',
                    redeem_text: 'Redeem With',
                    redeem:'Redeem',
                    rays: 'Rays',
                    valid_until: "Valid Until",
                    redeem_copy:"Copy and Use",
                    gift_card_code: 'Gift Card Code:',
                    check_email: 'Check Your Email',
                    free:"Free",
                    code:"Code",
                    coupon:"Coupon",
                    permanent_valid_text:"Permanent Valid",
                    rules:"Rules:",
                    view_history_rewards:'View History Rewards',
                    play_more: 'Play More',
                    coupon_title:'Congratulations! You got Coupon Code!',
                    gift_card_title_1:'Congratulations! You got Gift Card in your email!',
                    gift_card_title:'Congratulations! You got a Gift Card!',
                    product_coupon_title:"Congratulations! You got a Free Gift!",
                    rays_consum:"Rays Consumed:",
                    time:"Time:",
                    off:"OFF",
                    no_prize_title:"Thanks for Participation !",
                    no_draw_time_tips:"Daily spins used up. Join next time!",
                    no_enough_rays:"Insufficient Rays. Earn more to play!",
                    active_no_start_text:"The event hasn’t started yet. Stay tuned!"
                },
                invalid_email: 'Please enter a valid email address'
            };
            this.deMessages = {
                couponInfo: {
                    out_of_stock: 'Nicht vorrätig',
                    coupon_text: 'Verfügbar über',
                    available: 'Verfügbar',
                    usage_rules: 'Verwendungsregeln',
                    redeem_text: 'Einlösen mit',
                    redeem:'Einlösen',
                    rays: 'Rays',
                    valid_until: 'Gültig bis',
                    redeem_copy:"Kopieren und Verwenden",
                    gift_card_code: 'Geschenkkartencode:',
                    check_email: 'Überprüfen Sie Ihre E-Mail',
                    free:"Kostenlos",
                    code:"Code",
                    coupon:"Gutschein",
                    permanent_valid_text:"Unbefristet gültig",
                    rules:"Regeln:",
                    view_history_rewards:'Belohnungsverlauf anzeigen',
                    play_more: 'Mehr spielen',
                    coupon_title:'Glückwunsch! Du hast einen Gutschein-Code erhalten!',
                    gift_card_title_1:'Glückwunsch! Du hast eine Geschenkkarte per E-Mail erhalten!',
                    gift_card_title:'Glückwunsch! Du hast eine Geschenkkarte erhalten!',
                    product_coupon_title:"Glückwunsch! Du hast ein kostenloses Geschenk erhalten!",
                    rays_consum:"Verbrauchte Strahlen:",
                    time:"Zeit:",
                    off:"AUS",
                    no_prize_title:"Vielen Dank für Ihre Teilnahme !",
                    no_draw_time_tips:"Tägliche Drehungen aufgebraucht. Nächstes Mal dabei sein!",
                    no_enough_rays:"Nicht genug Strahlen. Verdiene mehr, um zu spielen!",
                    active_no_start_text:"Die Veranstaltung hat noch nicht begonnen. Bleib dran!"

                },
                invalid_email: 'Bitte geben Sie eine gültige E-Mail-Adresse ein'
            };
            this.jaMessages = {
                couponInfo: {
                    out_of_stock: '在庫切れ',
                    coupon_text: '以上で利用可能',
                    available: '利用可能',
                    usage_rules: '利用規則',
                    redeem_text: 'で交換',
                    redeem:'redeem',
                    rays: 'Rays',
                    valid_until: '有効期限',
                    redeem_copy:"コピーして使用",
                    gift_card_code: 'ギフトカードコード：',
                    check_email: 'メールを確認',
                    free:"無料",
                    code:"コード",
                    coupon:"クーポン",
                    permanent_valid_text:"永久有効",
                    rules:"ルール:",
                    view_history_rewards:'Goshuku rireki o hyōji',
                    play_more: 'もっとプレイ',
                    coupon_title:'おめでとうございます！クーポンコードを獲得しました！',
                    gift_card_title_1:'おめでとうございます！ギフトカードがメールに届きました！',
                    gift_card_title:'おめでとうございます！無料ギフトを獲得しました！',
                    product_coupon_title:"おめでとうございます！ギフトカードを獲得しました！",
                    rays_consum:"消費された光線:",
                    time:"時間:",
                    off:"オフ",
                    no_prize_title:"ご参加いただき、ありがとうございます！",
                    no_draw_time_tips:"本日の回数制限です。次回ご参加ください！",
                    no_enough_rays:"レイが不足しています。もっと集めてプレイしましょう！",
                    active_no_start_text:"イベントはまだ始まっていません。今しばらくお待ちください！"

                },
                invalid_email: '有効なメールアドレスを入力してください'
            };
            this.frMessages = {
                couponInfo: {
                    out_of_stock: 'En rupture de stock',
                    coupon_text: "Disponible dès",
                    available: 'Disponible',
                    usage_rules: 'Règles d\'utilisation',
                    redeem_text: 'Utiliser avec',
                    redeem:'Utiliser',
                    rays: 'Rays',
                    valid_until: "Valable jusqu'au",
                    redeem_copy:"Copier et utiliser",
                    gift_card_code: 'Code de carte cadeau :',
                    check_email: 'Vérifiez vos emails',
                    free:"Gratuit",
                    code:"Code",
                    coupon:"Coupon",
                    permanent_valid_text:"Valable à vie",
                    rules:"Règles:",
                    view_history_rewards:'Historique des récompenses',
                    play_more: 'Jouer davantage',
                    coupon_title:'Félicitations ! Vous avez reçu un code promo !',
                    gift_card_title_1:'Félicitations ! Vous avez reçu une carte cadeau par e-mail !',
                    gift_card_title:'Félicitations ! Vous avez reçu une carte cadeau !',
                    product_coupon_title:"Félicitations ! Vous avez reçu un cadeau gratuit !",
                    rays_consum:"Rayons consommés:",
                    time:"Temps:",
                    off:"ARRÊT",
                    no_prize_title:"Merci pour votre participation!",
                    no_draw_time_tips:"Tours quotidiens épuisés. À la prochaine !",
                    no_enough_rays:"Rayons insuffisants. Gagnez-en plus pour jouer !",
                    active_no_start_text:"L'événement n'a pas encore commencé. Restez à l'écoute !"


                },
                invalid_email: 'Veuillez saisir une adresse e-mail valide'
            };
            this.nlMessages = {
                couponInfo: {
                    out_of_stock: 'Niet op voorraad',
                    coupon_text: 'Beschikbaar vanaf',
                    available: 'Beschikbaar',
                    usage_rules: 'Gebruiksregels',
                    redeem_text: 'Inwisselen met',
                    redeem:'Inwisselen',
                    rays: 'Rays',
                    valid_until: 'Geldig tot',
                    redeem_copy:"Kopiëren en gebruiken",
                    gift_card_code: 'Cadeauboncode:',
                    check_email: 'Controleer uw e-mail',
                    free:"Gratis",
                    code:"Code",
                    coupon:"Coupon",
                    permanent_valid_text:"Permanent geldig",
                    rules:"Regels:",
                    view_history_rewards:'Beloningsgeschiedenis weergeven',
                    play_more: 'Meer spelen',
                    coupon_title:'Gefeliciteerd! Je hebt een kortingscode ontvangen!',
                    gift_card_title_1:'Gefeliciteerd! Je hebt een cadeaukaart per e-mail ontvangen!',
                    gift_card_title:'Gefeliciteerd! Je hebt een cadeaukaart ontvangen!',
                    product_coupon_title:"Gefeliciteerd! Je hebt een gratis cadeau ontvangen!",
                    rays_consum:"Verbrukte stralen:",
                    time:"Tijd:",
                    off:"UIT",
                    no_prize_title:"Wij danken u voor uw deelname!",
                    no_draw_time_tips:"Je dagelijkse draaiingen zijn op! Doe volgende keer nou weer mee!",
                    no_enough_rays:"Niet genoeg Strahlen. Verdien er meer om te spelen!",
                    active_no_start_text:"Het evenement is nog niet begonnen. Blijf op de hoogte!"


                },
                invalid_email: 'Voer een geldig e-mailadres in'
            };
            this.esMessages = {
                couponInfo: {
                    out_of_stock: 'Agotado',
                    coupon_text: "Disponible sobre",
                    available: 'Disponible',
                    usage_rules: 'Reglas de uso',
                    redeem_text: 'Canjear con',
                    redeem:'Canjear',
                    rays: 'Rays',
                    valid_until: "Válido hasta",
                    redeem_copy:"Copiar y usar",
                    gift_card_code: 'Código de tarjeta regalo:',
                    check_email: 'Revisa tu correo electrónico',
                    free:"Gratis",
                    code:"Código",
                    coupon:"Cupón",
                    permanent_valid_text:"Válido a perpetuidad",
                    rules:"Reglas:",
                    view_history_rewards:'Ver historial de recompensas',
                    play_more: 'Jugar más',
                    coupon_title:'¡Felicidades! ¡Recibiste un código de cupón!',
                    gift_card_title_1:'¡Felicidades! ¡Recibiste una tarjeta de regalo por correo electrónico!',
                    gift_card_title:'¡Felicidades! ¡Recibiste una tarjeta de regalo!',
                    product_coupon_title:"¡Felicidades! ¡Recibiste un regalo gratis!",
                    rays_consum:"Rayos consumidos:",
                    time:"Tiempo:",
                    off:"APAGADO",
                    no_prize_title:"Gracias por su participación!",
                    no_draw_time_tips:"Giros diarios agotados. ¡Únete la próxima vez!",
                    no_enough_rays:"Rayos insuficientes. ¡Gana más para jugar!",
                    active_no_start_text:"¡El evento aún no ha comenzado! Permanezca atento."

                },
                invalid_email: 'Por favor ingrese una dirección de correo electrónico válida'
            };
            this.itMessages = {
               couponInfo: {
                    out_of_stock: 'Esaurito',
                    coupon_text: "Disponibile sopra",
                    available: 'Disponibile',
                    usage_rules: 'Regole di utilizzo',
                    redeem_text: 'Riscatta con',
                    redeem:'Riscatta',
                    rays: 'Rays',
                    valid_until: "Valido fino a",
                    redeem_copy:"Copia e usa",
                    gift_card_code: 'Codice della carta regalo:',
                    check_email: 'Controlla la tua email',
                    free:"Gratis",
                    code:"Codice",
                    coupon:"Coupon",
                    permanent_valid_text:"Valido a tempo indeterminato",
                    rules:"Regole:",
                    view_history_rewards:'Vedi ricompense',
                    play_more: 'Gioca di più',
                    coupon_title:'Congratulazioni! Hai ricevuto un codice coupon!',
                    gift_card_title_1:'Congratulazioni! Hai ricevuto una carta regalo via email!',
                    gift_card_title:'Congratulazioni! Hai ricevuto una carta regalo!',
                    product_coupon_title:"Congratulazioni! Hai ricevuto un regalo gratuito!",
                    rays_consum:"Raggi consumati:",
                    time:"Tempo:",
                    off:"SPENTO",
                    no_prize_title:"Grazie per la partecipazione!",
                    no_draw_time_tips:"Giri del giorno finiti! Ci ritroviamo alla prossima!",
                    no_enough_rays:"Raggi insufficienti. Guadagnane di più per giocare!",
                    active_no_start_text:"L'evento non è ancora iniziato. Resta sintonizzato!"
                },
                invalid_email: 'Inserisci un indirizzo email valido'
            };


            // 根据语言选择对应版本
            const locale = window.Shopify?.locale || 'en';
            switch (locale.toLowerCase()) {
                case 'de':
                    this.messages = this.deMessages;
                    this.lang = 'de';
                    break;
                case 'ja':
                    this.messages = this.jaMessages;
                    this.lang = 'ja';
                    break;
                case 'fr':
                    this.messages = this.frMessages;
                    this.lang = 'fr';
                    break;
                case 'nl':
                    this.messages = this.nlMessages;
                    this.lang = 'nl';
                    break;
                case 'es':
                    this.messages = this.esMessages;
                    this.lang = 'es';
                    break;
                case 'it':
                    this.messages = this.itMessages;
                    this.lang = 'it';
                    break;
                default:
                    this.messages = this.enMessages;
                    break;
            }
            RaysLotteryRG.instance = this;
            this.debouncedViewPrizePopup = this.debounce(this.viewPrizePopup.bind(this), 500);
        }

        async init() {
            this.headSubtitle = this.raysLotteryRGContainer.querySelector('.rg-lottery-head-subtitle');
            this.playBtn = this.raysLotteryRGContainer.querySelector('.prize-product-item-play');
            this.raysLotteryRGContainer.querySelector('.rg-lottery-content-left-view-prize').style.display = 'none';
            
            if(this.customerEmail){
                await this.getPrizeStock();
                this.raysLotteryRGContainer.querySelector('.rg-lottery-content-left-view-prize').style.display = 'flex';
            }
            if(!this.allOutOfStock){
                this.renderPrizeStock();
            }else{
                this.renderNoPrizeStock();
            }
            if(this.raysLotteryRGContainer.getAttribute("customer-email")){
                this.customerEmail = this.raysLotteryRGContainer.getAttribute("customer-email");
                await this.getMerberData();
            }
            if (this.raysLotteryRGContainer && this.accessToken && this.refreshToken) {
                this.showViewPrizeButton();
            }
            if(this.raysLotteryRGContainer) {
                this.renderActivePrizeStatus();
                if(this.raysLotteryRGContainer.querySelector('.rg-lottery-content-left-learn-more-rules-button')){
                    this.raysLotteryRGContainer.querySelector('.rg-lottery-content-left-learn-more-rules-button').addEventListener('click', (event) => {
                        if(!event.target.href){
                            event.preventDefault();
                            this.learnMoreRules();
                        }
                    });
                }
            }
            // TODOLIST: 使用事件委托，只添加一次全局点击监听器
            if (!this.eventListenersInitialized) {
                document.addEventListener('click', this.debounce((event) => {
                    if (event.target.classList.contains('prize-product-item-play')) {
                        this.playBtn.disabled = true;
                        const startTargetDate = new Date(window.raysLotteryBlocksData.settings.time_start).getTime();
                        const now = Date.now();
                        let raysLotteryCount = Number(this.getLotteryCookie(this.activity)?.raysLotteryCount||0) || 0
                        if(this.noLogin){
                            return;
                        }
                        if (now < startTargetDate) {
                            this.renderToast(this.toastTipsIcon,this.messages.couponInfo.active_no_start_text,3000);
                            return;
                        }
                        else if(raysLotteryCount >= window.raysLotteryBlocksData.settings.active_lottery_draw_time && !this.allOutOfStock){
                            this.renderToast(this.toastTipsIcon,this.messages.couponInfo.no_draw_time_tips,3000);
                        }else if(this.customerPoints < window.raysLotteryBlocksData.settings.lottery_vip_points){
                            this.renderToast(this.toastIconNoPoints,this.messages.couponInfo.no_enough_rays,3000);
                        }
                        else if(!this.allOutOfStock && 
                            this.customerPoints >= window.raysLotteryBlocksData.settings.lottery_vip_points && 
                            raysLotteryCount < window.raysLotteryBlocksData.settings.active_lottery_draw_time){
                            this.submitForm();
                        }
                    }
                    if (event.target.classList.contains('rg-lottery-content-left-view-prize-button')) {
                        this.debouncedViewPrizePopup();
                    }
                },500));
                this.eventListenersInitialized = true;
            }
        }
        // 防抖处理
        debounce(func, wait, immediate = false) {
            let timeout;

            return function executedFunction(...args) {
            const context = this;

            const later = function() {
                timeout = null;
                if (!immediate) func.apply(context, args);
            };

            const callNow = immediate && !timeout;

            clearTimeout(timeout);
            timeout = setTimeout(later, wait);

            if (callNow) func.apply(context, args);
            };
        }
        // 判断活动开始状态
        renderActivePrizeStatus(){
            const startTime = window.raysLotteryBlocksData.settings.time_start;
            const endTime = window.raysLotteryBlocksData.settings.time_end;
            const startTargetDate = new Date(startTime).getTime();
            const endTargetDate = new Date(endTime).getTime();
            const now = Date.now();
            this.startTimeWrapper = this.raysLotteryRGContainer.querySelector('.coupon-lottery-countdown-start') ? this.raysLotteryRGContainer.querySelector('.coupon-lottery-countdown-start') : null;
            this.endTimeWrapper = this.raysLotteryRGContainer.querySelector('.coupon-lottery-countdown-end') ? this.raysLotteryRGContainer.querySelector('.coupon-lottery-countdown-end') : null;

            if(startTargetDate > now ){
                this.playBtn.innerHTML = window.raysLotteryBlocksData.settings.play_btn_not_start;
                if(this.headSubtitle){
                    this.headSubtitle.innerHTML = window.raysLotteryBlocksData.settings.tips_not_start;
                    this.headSubtitle.style.display = 'block';
                }
                
                if(this.startTimeWrapper) this.startTimeWrapper.style.display = 'flex'
                if(this.endTimeWrapper) this.endTimeWrapper.style.display = 'none'
            }
            if(startTargetDate < now){
                if(this.startTimeWrapper) this.startTimeWrapper.style.display = 'none';
                if((endTargetDate - now) <= 3*1000*60*60*24 ){
                    if(this.endTimeWrapper) this.endTimeWrapper.style.display = 'flex'
                }else{
                    if(this.endTimeWrapper) this.endTimeWrapper.style.display = 'none'
                }
            }
            if(endTargetDate < now){
                this.playBtn.innerHTML = window.raysLotteryBlocksData.settings.active_play_btn_text_ended;
                if(this.headSubtitle){
                    this.headSubtitle.innerHTML = window.raysLotteryBlocksData.settings.active_tips_text_ended;
                    this.headSubtitle.style.display = 'block';
                }
                if(this.raysLotteryRGContainer.querySelector('.rg-rays-lottery-countdown')) this.raysLotteryRGContainer.querySelector('.rg-rays-lottery-countdown').style.display = 'none';
                this.playBtn.classList.add('prize-product-item-play-other');
                this.playBtn.disabled = true;
            }
            const startWrapper = this.raysLotteryRGContainer.querySelector('.coupon-lottery-countdown-start');
            const endWrapper = this.raysLotteryRGContainer.querySelector('.coupon-lottery-countdown-end');
            if(this.startTimeWrapper){
                const startInterVal = setInterval(() => {
                    this.updateCountdown(startInterVal,this.startTimeWrapper, startTime);
                }, 1000);
            }
            if(this.endTimeWrapper){
                const endInterVal = setInterval(() => {
                    this.updateCountdown(endInterVal,this.endTimeWrapper, endTime);
                }, 1000);
            }
        }
        updateCountdown(interval, countDownWrapper, targetTime) {
            const targetDate = new Date(targetTime).getTime();
            const now = Date.now();
            let timeLeft = Math.max(0, targetDate - now);

            // TODOLIST: 页面可见性检测 - 只添加一次监听器
            // 注意：当页面从隐藏状态恢复时，需要重新计算时间，但不需要重新调用整个方法
            // 因为 setInterval 会继续执行，只需要在下次执行时使用正确的时间即可
            if (!this.visibilityChangeListenerAdded) {
                document.addEventListener('visibilitychange', () => {
                    // 当页面变为可见时，时间会在下次 updateCountdown 调用时自动重新计算
                    // 这里不需要额外操作，因为 setInterval 会继续运行
                });
                this.visibilityChangeListenerAdded = true;
            }

            if (timeLeft === 0 || timeLeft < 0) {
                clearInterval(interval);
            } else {
                const days = Math.floor(timeLeft / (1000 * 60 * 60 * 24));
                const formattedDays = days < 10 ? '0' + days : days;
                const hours = Math.floor((timeLeft % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
                const formattedHours = hours < 10 ? '0' + hours : hours;
                const minutes = Math.floor((timeLeft % (1000 * 60 * 60)) / (1000 * 60));
                const formattedMinutes = minutes < 10 ? '0' + minutes : minutes;
                const seconds = Math.floor((timeLeft % (1000 * 60)) / 1000);
                const formattedSeconds = seconds < 10 ? '0' + seconds : seconds;
                this.updateNumberWithAnimation(countDownWrapper.querySelector('.countdown-day'), formattedDays);
                this.updateNumberWithAnimation(countDownWrapper.querySelector('.countdown-hour'), formattedHours);
                this.updateNumberWithAnimation(countDownWrapper.querySelector('.countdown-minutes'), formattedMinutes);
                this.updateNumberWithAnimation(countDownWrapper.querySelector('.countdown-second'), formattedSeconds);
            }
        }
        
        updateNumberWithAnimation(element, newValue) {
            const currentNumber = element.querySelector('.countdown-number');
            const nextNumber = element.querySelector('.countdown-number-next');

            // 获取当前显示的数字
            const currentDisplayValue = currentNumber.textContent.trim();
            
            // 如果数字没有变化，直接返回，不执行动画
            if (currentDisplayValue === newValue.toString()) {
                return;
            }

            
            nextNumber.textContent = newValue;
            
            // 移除旧动画
            currentNumber.classList.remove('roll-down-old');
            nextNumber.classList.remove('roll-down-new');
            
            // 强制重绘
            void element.offsetWidth;
            
            // 应用新动画
            currentNumber.classList.add('roll-down-old');
            nextNumber.classList.add('roll-down-new');
            
            // 动画结束后交换角色
            setTimeout(() => {
                currentNumber.textContent = newValue;
                currentNumber.classList.remove('roll-down-old');
                nextNumber.classList.remove('roll-down-new');
                
                // 重置位置
                currentNumber.style.transform = 'translateY(0)';
                nextNumber.style.transform = 'translateY(-100%)';
            }, 500);
        }

        // 渲染没有奖品
        renderNoPrizeStock(){
            this.headSubtitle.innerHTML = window.raysLotteryBlocksData.settings.active_no_stock_text;
            this.headSubtitle.style.display = 'block';
            if(this.raysLotteryRGContainer.querySelector('.rg-rays-lottery-countdown')) this.raysLotteryRGContainer.querySelector('.rg-rays-lottery-countdown').style.display = 'none';
            this.playBtn.innerHTML = window.raysLotteryBlocksData.settings.play_btn_no_stock;
            this.playBtn.classList.add('prize-product-item-play-other');
            this.playBtn.disabled = true;
        }

        // 渲染有奖品
        renderPrizeStock(){
            this.playBtn.removeAttribute("disabled");
            if(this.raysLotteryRGContainer.querySelector('.rg-rays-lottery-countdown')) this.raysLotteryRGContainer.querySelector('.rg-rays-lottery-countdown').style.display = 'block';
        }

        // 判断是否显示 view prize
        showViewPrizeButton() {
            // TODOLIST: 使用事件委托，只添加一次复制按钮点击监听器
            if (!this.copyButtonListenerAdded) {
                document.addEventListener('click', (event) => {
                    if (event.target.classList.contains('membership-coupon-b-top-button-copy') && event.target.getAttribute('data-copy-coupon')) {
                        this.copyToClipboard(event.target.getAttribute('data-copy-coupon'), event.target);
                    }
                });
                this.copyButtonListenerAdded = true;
            }
        }

        copyToClipboard(coupon,copyButton){
            let coupon_ = JSON.parse(coupon);
            if(coupon_.prizeDetail.type == 'coupon_code'){
                if (copyButton.classList.contains('copied')) return;
                    
                    navigator.clipboard.writeText(coupon_.prizeDetail.value).then(() => {
                        // 显示打勾SVG图标
                        const originalText = copyButton.textContent;
                        copyButton.innerHTML = `${originalText}
                            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M13.3332 4L5.99984 11.3333L2.6665 8" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                        `;
                        copyButton.classList.add('copied');
                        
                        // 3秒后恢复原始状态
                        setTimeout(() => {
                            copyButton.innerHTML = originalText;
                            copyButton.classList.remove('copied');
                        }, 3000);
                    }).catch(err => {
                        console.error('Failed to copy coupon code: ', err);
                });
            }
            if(coupon_.prizeDetail.type == 'product_coupon'){
                let maxTime= 0
                let copyButtonTimer = setInterval(() => {
                    if(copyButton.classList.contains('is-success')){
                        Swal.close();
                        clearInterval(copyButtonTimer);
                    }
                    maxTime += 50;
                }, 10);
                if(maxTime >= 3000){
                    Swal.close();
                    clearInterval(copyButtonTimer);
                }
                // 防止重复点击
                if (copyButton.classList.contains('copied')) return;
                
                navigator.clipboard.writeText(coupon_.prizeDetail.value).then(() => {
                    // 显示打勾SVG图标
                    const originalText = copyButton.textContent;
                    copyButton.classList.add('copied');
                    
                    // 3秒后恢复原始状态
                    setTimeout(() => {
                        copyButton.innerHTML = originalText;
                        copyButton.classList.remove('copied');
                    }, 3000);
                }).catch(err => {
                    console.error('Failed to copy coupon code: ', err);
                });
            }
        }
    
        // View Prize Popup
        async viewPrizePopup() {
            let rgLotteryItem = ``;
            const shopCurrency = window.Shopify.currency.active || 'USD';
            const shopLocale = window.Shopify.locale + '-' + window.Shopify.country || 'en-GB';
            const formatter = new Intl.NumberFormat(shopLocale, {
                style: 'currency',
                currency: shopCurrency
            });
            const currency = formatter.formatToParts(0).find(p => p.type === 'currency').value;
            
            // 初始化分页变量
            this.currentPage = 1;
            this.pageSize = 10;
            this.totalPages = 1;
            this.isLoadingMore = false;
            
            // 获取第一页数据
            const result = await this.getPrizeHistory(this.currentPage, this.pageSize);
            this.totalPages = result.totalPages || 1;
            if(this.raysLotteryUserList.length > 0){
                let rgLotteryContent = ``;
                rgLotteryItem = `<div class="membership-coupon-dialog-content-success membership-coupon-container">
                    <div class="membership-coupon-dialog-title">
                        ${this.customerEmail}
                    </div>
                </div>`;
                this.raysLotteryUserList.forEach((coupon) => { 
                    let membershipCouponRuleHtml = ``;
                    if(coupon?.prizeDetail?.rules?.length > 0) {
                        membershipCouponRuleHtml = coupon?.prizeDetail?.rules;
                    }
                    if(coupon.prizeDetail?.type === 'coupon_code'){
                        rgLotteryContent = `
                        <div class="membership-coupon-dialog-content-success membership-coupon-container">
                            <div class="membership-coupon-item">
                                <div class="membership-coupon-top">
                                    <div class="coupon-l">
                                        <div class="coupon-name">
                                            ${coupon.prizeDetail?.title?.includes('%') == false ? `<span class="copun-currency">${currency}</span>
                                            <span x-text="coupon.couponAmount">
                                                ${coupon.prizeDetail?.title?.replace(currency, '')?.trim()}
                                            </span>
                                            `:'' }
                                            ${coupon.prizeDetail?.title.includes('%') ? `
                                                <span x-text="coupon.couponAmount">
                                                ${coupon.prizeDetail?.title?.replace('%', '')?.trim()}
                                            </span><span class="copun-currency">%</span>`:'' }
                                            <span class="off-text">${this.messages.couponInfo.off}</span>
                                        </div>
                                        <div class="account-coupon-info">
                                            ${coupon.prizeDetail?.useLimit || ''}
                                        </div>
                                    </div>
                                </div>
                                <div class="membership-coupon-b">
                                    <div class="membership-coupon-b-top">
                                        <div class="membership-coupon-b-top-content">
                                            <div class="membership-coupon-b-top-content-title">${this.messages.couponInfo.code}</div>
                                            <div class="membership-coupon-b-top-content-des">
                                                ${coupon.prizeDetail?.value || ''}
                                            </div>
                                        </div>
                                        <div class="membership-coupon-b-top-button membership-coupon-b-top-button-copy" data-copy-coupon='${JSON.stringify(coupon)}'>
                                            ${this.messages.couponInfo.redeem_copy}
                                        </div>
                                        
                                    </div>
                                    <div class="membership-coupon-b-line"></div>
                                    <div class="membership-coupon-b-bottom">
                                        <div class="membership-coupon-b-bottom-time">
                                            ${coupon.prizeDetail?.validate ||  ''}
                                        </div>
                                    </div>
                                    
                                </div>
                            </div>
                            <div class="membership-coupon-b-bottom-rules-container">
                                <div class="membership-coupon-b-bottom-rules-title">${this.messages.couponInfo.rules}</div>
                                <div class="membership-coupon-b-bottom-rules-box">
                                    ${membershipCouponRuleHtml}
                                </div> 
                            </div>
                            <div class="membership-coupon-other">
                                <div class="membership-coupon-other-rays">
                                    ${this.messages.couponInfo.rays_consum}
                                    <span>
                                        ${coupon.limit.costRays}
                                    </span>
                                </div>
                                <div class="membership-coupon-other-time">
                                    ${this.messages.couponInfo.time}
                                    <span>
                                        ${this.formatDateTimeForTimezone(coupon.createdAt,this.storeName,true)}
                                    </span>
                                </div>
                            </div>
                        </div>`;
                    }
                    if(coupon.prizeDetail?.type === 'gift_card'){
                        rgLotteryContent = `
                        <div class="membership-coupon-dialog-content-success membership-coupon-container gift-card-coupon-dialog-success">
                            <div class="membership-coupon-item">
                                <div class="membership-coupon-top">
                                    <div class="coupon-l">
                                        <div class="coupon-name">
                                            <span class="copun-currency">${currency}</span>
                                            <span x-text="coupon.couponAmount">${coupon?.prizeDetail?.value || ''}</span>
                                        </div>
                                        <div class="account-coupon-info">
                                            ${coupon?.prizeDetail?.useLimit || ''}
                                        </div>
                                    </div>
                                </div>
                                <div class="membership-coupon-b">
                                    <div class="membership-coupon-b-top">
                                        <div class="membership-coupon-b-top-content">
                                            <div class="membership-coupon-b-top-content-title">${this.messages.couponInfo.gift_card_code}</div>
                                            <div class="membership-coupon-b-top-content-des">
                                                ${this.messages.couponInfo.check_email}
                                            </div>
                                        </div>
                                    </div>
                                    <div class="membership-coupon-b-line"></div>
                                    <div class="membership-coupon-b-bottom">
                                        <div class="membership-coupon-b-bottom-time">
                                            ${coupon?.prizeDetail?.validate}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="membership-coupon-b-bottom-rules-container">
                                <div class="membership-coupon-b-bottom-rules-title">${this.messages.couponInfo.rules}</div>
                                <div class="membership-coupon-b-bottom-rules-box">
                                    ${membershipCouponRuleHtml}
                                </div> 
                            </div>
                            <div class="membership-coupon-other">
                                <div class="membership-coupon-other-rays">
                                    ${this.messages.couponInfo.rays_consum}
                                    <span>
                                        ${coupon.limit.costRays}
                                    </span>
                                </div>
                                <div class="membership-coupon-other-time">
                                    ${this.messages.couponInfo.time}
                                    <span>
                                        ${this.formatDateTimeForTimezone(coupon.createdAt,this.storeName,true)}
                                    </span>
                                </div>
                            </div>
                        </div>`;
                    }
                    if(coupon.prizeDetail?.type === 'product_coupon'){
                        
                        rgLotteryContent = `
                        <div class="membership-coupon-dialog-content-success membership-coupon-container product-card-coupon-dialog-success">
                            <div class="membership-coupon-item">
                                <div class="membership-coupon-top membership-coupon-product-card">
                                    ${coupon?.prizeDetail?.productDetail?.image?
                                    `<div class="product-card-img" >
                                        <img width="100%" src="${coupon?.prizeDetail?.productDetail?.image}" />
                                    </div>`:
                                    `<div class="product-card-img" style="background:#F2FCFF;"></div>`}
                                    <div class="product-card-content">
                                        <a class="product-card-content-title" target="_blank" href="${coupon?.prizeDetail?.productDetail?.link}">${coupon?.prizeDetail?.productDetail?.name || ''}</a>

                                        <div class="product-card-content-sku">${coupon?.prizeDetail?.productDetail?.sku || ''}</div>
                                        <div class="product-card-content-price">
                                            <span class="free">${this.messages.couponInfo.free}</span>
                                            ${coupon?.prizeDetail?.productDetail?.price ? `<span class="underline-price">${ formatter.format(coupon?.prizeDetail?.productDetail?.price) }</span>` :''}
                                        </div>
                                    </div>
                                </div>
                                <div class="membership-coupon-item-line-box">
                                    <div class="membership-coupon-item-line"></div>
                                </div>
                                <div class="membership-coupon-b">
                                    <div class="membership-coupon-b-top">
                                        <div class="membership-coupon-b-top-content">
                                            <div class="membership-coupon-b-top-content-title">${this.messages.couponInfo.code}:
                                                <span class="membership-coupon-b-top-content-des">
                                                    ${coupon?.prizeDetail?.value || ''}
                                                </span>
                                            </div>
                                        </div>
                                        ${coupon?.prizeDetail?.productDetail?.variantId ? `<product-form>
                                            <form class="js-product-form" id="form-id-${coupon?.prizeDetail?.productDetail?.variantId}"  method="post" action="/cart/add" enctype="multipart/form-data" novalidate="novalidate" accept-charset="UTF-8">
                                                <input type="hidden" name="form_type" value="product"><input type="hidden" name="utf8" value="✓">
                                                <input type="hidden" name="id" value="${coupon?.prizeDetail?.productDetail?.variantId}" disabled>
                                                <button name="add" class="membership-coupon-b-top-button membership-coupon-b-top-button-copy btn btn--secondary quick-add-view-btn" data-copy-coupon='${JSON.stringify(coupon)}'>
                                                    ${this.messages.couponInfo.redeem_copy}
                                                </button>
                                            </form>
                                        </product-form>` : `
                                            <product-form>
                                                <form class="js-product-form" id="form-id-${coupon?.prizeDetail?.productDetail?.productId}"  method="post" action="/cart/add" enctype="multipart/form-data" novalidate="novalidate" accept-charset="UTF-8">
                                                    <input type="hidden" name="form_type" value="product"><input type="hidden" name="utf8" value="✓">
                                                    <input type="hidden" name="id" value="${coupon?.prizeDetail?.productDetail?.productId}" disabled>
                                                    <button name="add" class="membership-coupon-b-top-button membership-coupon-b-top-button-copy btn btn--secondary quick-add-view-btn" data-copy-coupon='${JSON.stringify(coupon)}'>
                                                        ${this.messages.couponInfo.redeem_copy}
                                                    </button>
                                                </form>
                                            </product-form>
                                        `}
                                        
                                    </div>
                                    <div class="membership-coupon-b-bottom">
                                        <div class="membership-coupon-b-bottom-time">
                                            ${coupon?.prizeDetail?.validate || ''}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="membership-coupon-b-bottom-rules-container">
                                <div class="membership-coupon-b-bottom-rules-title">${this.messages.couponInfo.rules}</div>
                                <div class="membership-coupon-b-bottom-rules-box">
                                    ${membershipCouponRuleHtml}
                                </div> 
                            </div>
                            <div class="membership-coupon-other">
                                <div class="membership-coupon-other-rays">
                                    ${this.messages.couponInfo.rays_consum}
                                    <span>
                                        ${coupon.limit.costRays}
                                    </span>
                                </div>
                                <div class="membership-coupon-other-time">
                                    ${this.messages.couponInfo.time}
                                    <span>
                                        ${this.formatDateTimeForTimezone(coupon.createdAt,this.storeName,true)}
                                    </span>
                                </div>
                            </div>
                        </div>
                    `
                    }
                    if(coupon.prizeDetail?.type === 'none' || coupon.prizeDetail?.type === 'prize_none'){
                        
                        rgLotteryContent = `
                        <div class="membership-coupon-dialog-content-success membership-coupon-container">
                            <div class="membership-coupon-dialog-title-no-prize">${this.messages.couponInfo.no_prize_title || 'Thanks for Participation'}</div>
                            <div class="membership-coupon-other">
                                <div class="membership-coupon-other-rays">
                                    ${this.messages.couponInfo.rays_consum}
                                    <span>
                                        ${coupon.limit.costRays}
                                    </span>
                                </div>
                                <div class="membership-coupon-other-time">
                                    ${this.messages.couponInfo.time}
                                    <span>
                                        ${this.formatDateTimeForTimezone(coupon.createdAt,this.storeName,true)}
                                    </span>
                                </div>
                            </div>
                        </div>`;
                    }
                    rgLotteryItem += `<div class="rg-lottery-item">
                        ${rgLotteryContent}
                    </div>`
                })
                rgLotteryItem += `
                
                <div class="rg-lottery-item rg-lottery-operation">
                    <a class="rg-lottery-view-rewards" href="/pages/lucky-draw-prize">
                        ${this.messages.couponInfo.view_history_rewards}
                    </a>
                    <div class="rg-lottery-play-more">
                        ${this.messages.couponInfo.play_more}
                    </div>
                </div>`
                
                // 如果有更多页，添加哨兵元素用于IntersectionObserver检测
                if(this.currentPage < this.totalPages) {
                    rgLotteryItem += `
                    <div class="rg-lottery-loading-sentinel" style="height: 1px; visibility: hidden;"></div>`;
                }
            }else{
                rgLotteryItem += `
                <div class="membership-coupon-dialog-content-success membership-coupon-container coupon-dialog-no-rewards">
                    <div class="membership-coupon-dialog-title">
                        ${this.customerEmail}
                    </div>
                    <div class="rg-lottery-view-img">
                        <img src="${window.raysLotteryBlocksData.settings.view_prize_no_prize_img}" />
                    </div>
                    <div class="rg-lottery-view-text">
                        ${window.raysLotteryBlocksData.settings.view_prize_no_prize_text}
                    </div>
                    <div class="rg-lottery-item rg-lottery-operation">
                        <div class="rg-lottery-play-more">
                            ${window.raysLotteryBlocksData.settings.play_btn_text}
                        </div>
                    </div>
                </div>
                `
            }
            const prizeHtml = `
                <div class="rg-lottery-container">
                    ${rgLotteryItem}
                </div>
            `;
            // TODOLIST: 使用事件委托处理"Play More"按钮，通过事件冒泡处理动态添加的元素
            // 注意：这个监听器会在每次打开弹窗时检查，但由于使用事件委托，不会重复添加
            const playMoreHandler = (event) => {
                if (event.target.classList.contains('rg-lottery-play-more')) {
                    Swal.close();
                    // 移除监听器，避免内存泄漏
                    document.removeEventListener('click', playMoreHandler);
                }
            };
            document.addEventListener('click', playMoreHandler);
            
            Swal.fire({
                showCloseButton: true,
                showCancelButton: false,
                showConfirmButton: false,
                html: prizeHtml,
                closeButtonHtml: this.closeBtnHtml,
                customClass: {
                    container: "membership-coupon-popup-container",
                    popup: "membership-coupon-popup",
                },
                didOpen: () => {
                    // 设置滚动加载更多
                    if(this.currentPage < this.totalPages) {
                        this.setupScrollLoadMore(currency, formatter);
                    }
                },
                willClose: () => {
                    // 清理滚动监听器
                    this.cleanupScrollListener();
                }
            });
        }

        // 设置滚动加载更多
        setupScrollLoadMore(currency, formatter) {
            // 等待DOM完全渲染
            setTimeout(() => {
                const popup = document.querySelector('.membership-coupon-popup');
                const container = popup?.querySelector('.rg-lottery-container');
                const sentinel = container?.querySelector('.rg-lottery-loading-sentinel');
                
                if (!popup || !container) {
                    return;
                }

                // 找到实际可滚动的元素
                let scrollElement = null;
                const possibleScrollElements = [
                    document.querySelector('.swal2-html-container'),
                    document.querySelector('.swal2-container'),
                    popup.closest('.swal2-container'),
                    popup,
                    container
                ];
                
                for (const elem of possibleScrollElements) {
                    if (elem) {
                        const computedStyle = window.getComputedStyle(elem);
                        const hasScroll = elem.scrollHeight > elem.clientHeight || 
                                         computedStyle.overflow === 'auto' || 
                                         computedStyle.overflowY === 'auto' ||
                                         computedStyle.overflow === 'scroll' ||
                                         computedStyle.overflowY === 'scroll';
                        if (hasScroll) {
                            scrollElement = elem;
                            break;
                        }
                    }
                }
                
                if (!scrollElement) {
                    scrollElement = popup;
                }

                // 防抖处理滚动事件
                let scrollTimer = null;
                const scrollHandler = () => {
                    if (scrollTimer) {
                        clearTimeout(scrollTimer);
                    }
                    
                    scrollTimer = setTimeout(() => {
                        const scrollTop = scrollElement.scrollTop;
                        const scrollHeight = scrollElement.scrollHeight;
                        const clientHeight = scrollElement.clientHeight;
                        const distanceToBottom = scrollHeight - scrollTop - clientHeight;
                        
                        // 距离底部50px时触发加载 - 判断是否可以加载下一页（currentPage + 1 <= totalPages）
                        if (distanceToBottom < 50 && !this.isLoadingMore && this.currentPage < this.totalPages) {
                            this.loadMorePrizes(currency, formatter, popup, container);
                        }
                    }, 100);
                };

                // 添加滚动监听
                scrollElement.addEventListener('scroll', scrollHandler, { passive: true });
                popup.addEventListener('scroll', scrollHandler, { passive: true });
                container.addEventListener('scroll', scrollHandler, { passive: true });
                
                // 使用 IntersectionObserver 作为备选方案
                if (sentinel && 'IntersectionObserver' in window) {
                    const observer = new IntersectionObserver((entries) => {
                        entries.forEach(entry => {
                            if (entry.isIntersecting && !this.isLoadingMore && this.currentPage < this.totalPages) {
                                this.loadMorePrizes(currency, formatter, popup, container);
                            }
                        });
                    }, {
                        root: scrollElement === popup || scrollElement === document.body ? null : scrollElement,
                        rootMargin: '50px',
                        threshold: 0.1
                    });
                    
                    observer.observe(sentinel);
                    this.scrollObserver = observer;
                    this.scrollSentinel = sentinel;
                }
                
                // 保存监听器引用以便清理
                this.scrollHandler = scrollHandler;
                this.scrollPopup = popup;
                this.scrollContainer = container;
                this.scrollElement = scrollElement;
            }, 300);
        }

        // 清理滚动监听器
        cleanupScrollListener() {
            if (this.scrollHandler) {
                if (this.scrollPopup) {
                    this.scrollPopup.removeEventListener('scroll', this.scrollHandler);
                }
                if (this.scrollContainer) {
                    this.scrollContainer.removeEventListener('scroll', this.scrollHandler);
                }
                if (this.scrollElement) {
                    this.scrollElement.removeEventListener('scroll', this.scrollHandler);
                }
            }
            if (this.scrollObserver) {
                this.scrollObserver.disconnect();
                this.scrollObserver = null;
            }
            this.scrollHandler = null;
            this.scrollPopup = null;
            this.scrollContainer = null;
            this.scrollElement = null;
            this.scrollSentinel = null;
        }

        // 加载更多奖品数据
        async loadMorePrizes(currency, formatter, popup, container) {
            // 如果正在加载，直接返回
            if (this.isLoadingMore) {
                return;
            }
            
            // 检查是否可以加载下一页：currentPage + 1 <= totalPages
            // 例如：currentPage=1, totalPages=3，可以请求第2页（currentPage++ = 2）
            //      currentPage=2, totalPages=3，可以请求第3页（currentPage++ = 3）
            //      currentPage=3, totalPages=3，不能再请求
            if (this.currentPage >= this.totalPages) {
                return;
            }

            this.isLoadingMore = true;

            try {
                // 记录追加前的数据长度（必须在调用 getPrizeHistory 之前）
                const previousLength = this.raysLotteryUserList.length;
                
                // 请求下一页数据（先增加页码再请求）
                const nextPage = this.currentPage + 1;
                this.currentPage = nextPage;
                const result = await this.getPrizeHistory(this.currentPage, this.pageSize, true);
                
                // 更新总页数（以防后端返回的值有变化）
                if (result.totalPages) {
                    this.totalPages = result.totalPages;
                }
                
                if (result.records && result.records.length > 0) {
                    // 找到操作按钮容器和哨兵元素
                    const operationContainer = container.querySelector('.rg-lottery-operation');
                    const sentinel = container.querySelector('.rg-lottery-loading-sentinel');
                    
                    // 生成新数据的HTML（只生成新增的部分）
                    let newItemsHtml = '';
                    for (let i = previousLength; i < this.raysLotteryUserList.length; i++) {
                        const coupon = this.raysLotteryUserList[i];
                        let membershipCouponRuleHtml = ``;
                        if(coupon?.prizeDetail?.rules?.length > 0) {
                            membershipCouponRuleHtml = coupon?.prizeDetail?.rules;
                        }
                        
                        let rgLotteryContent = ``;
                        
                        if(coupon.prizeDetail?.type === 'coupon_code'){
                            rgLotteryContent = `
                            <div class="membership-coupon-dialog-content-success membership-coupon-container">
                                <div class="membership-coupon-item">
                                    <div class="membership-coupon-top">
                                        <div class="coupon-l">
                                            <div class="coupon-name">
                                                ${coupon.prizeDetail?.title?.includes('%') == false ? `<span class="copun-currency">${currency}</span>
                                                <span x-text="coupon.couponAmount">
                                                    ${coupon.prizeDetail?.title?.replace(currency, '')?.trim()}
                                                </span>
                                                `:'' }
                                                ${coupon.prizeDetail?.title.includes('%') ? `
                                                    <span x-text="coupon.couponAmount">
                                                    ${coupon.prizeDetail?.title?.replace('%', '')?.trim()}
                                                </span><span class="copun-currency">%</span>`:'' }
                                                <span class="off-text">${this.messages.couponInfo.off}</span>
                                            </div>
                                            <div class="account-coupon-info">
                                                ${coupon.prizeDetail?.useLimit || ''}
                                            </div>
                                        </div>
                                    </div>
                                    <div class="membership-coupon-b">
                                        <div class="membership-coupon-b-top">
                                            <div class="membership-coupon-b-top-content">
                                                <div class="membership-coupon-b-top-content-title">${this.messages.couponInfo.code}</div>
                                                <div class="membership-coupon-b-top-content-des">
                                                    ${coupon.prizeDetail?.value || ''}
                                                </div>
                                            </div>
                                            <div class="membership-coupon-b-top-button membership-coupon-b-top-button-copy" data-copy-coupon='${JSON.stringify(coupon)}'>
                                                ${this.messages.couponInfo.redeem_copy}
                                            </div>
                                            
                                        </div>
                                        <div class="membership-coupon-b-line"></div>
                                        <div class="membership-coupon-b-bottom">
                                            <div class="membership-coupon-b-bottom-time">
                                                ${coupon.prizeDetail?.validate ||  ''}
                                            </div>
                                        </div>
                                        
                                    </div>
                                </div>
                                <div class="membership-coupon-b-bottom-rules-container">
                                    <div class="membership-coupon-b-bottom-rules-title">${this.messages.couponInfo.rules}</div>
                                    <div class="membership-coupon-b-bottom-rules-box">
                                        ${membershipCouponRuleHtml}
                                    </div> 
                                </div>
                                <div class="membership-coupon-other">
                                    <div class="membership-coupon-other-rays">
                                        ${this.messages.couponInfo.rays_consum}
                                        <span>
                                            ${coupon.limit.costRays}
                                        </span>
                                    </div>
                                    <div class="membership-coupon-other-time">
                                        ${this.messages.couponInfo.time}
                                        <span>
                                            ${this.formatDateTimeForTimezone(coupon.createdAt,this.storeName,true)}
                                        </span>
                                    </div>
                                </div>
                            </div>`;
                        }
                        if(coupon.prizeDetail?.type === 'gift_card'){
                            rgLotteryContent = `
                            <div class="membership-coupon-dialog-content-success membership-coupon-container gift-card-coupon-dialog-success">
                                <div class="membership-coupon-item">
                                    <div class="membership-coupon-top">
                                        <div class="coupon-l">
                                            <div class="coupon-name">
                                                <span class="copun-currency">${currency}</span>
                                                <span x-text="coupon.couponAmount">${coupon?.prizeDetail?.value || ''}</span>
                                            </div>
                                            <div class="account-coupon-info">
                                                ${coupon?.prizeDetail?.useLimit || ''}
                                            </div>
                                        </div>
                                    </div>
                                    <div class="membership-coupon-b">
                                        <div class="membership-coupon-b-top">
                                            <div class="membership-coupon-b-top-content">
                                                <div class="membership-coupon-b-top-content-title">${this.messages.couponInfo.gift_card_code}</div>
                                                <div class="membership-coupon-b-top-content-des">
                                                    ${this.messages.couponInfo.check_email}
                                                </div>
                                            </div>
                                        </div>
                                        <div class="membership-coupon-b-line"></div>
                                        <div class="membership-coupon-b-bottom">
                                            <div class="membership-coupon-b-bottom-time">
                                                ${coupon?.prizeDetail?.validate}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="membership-coupon-b-bottom-rules-container">
                                    <div class="membership-coupon-b-bottom-rules-title">${this.messages.couponInfo.rules}</div>
                                    <div class="membership-coupon-b-bottom-rules-box">
                                        ${membershipCouponRuleHtml}
                                    </div> 
                                </div>
                                <div class="membership-coupon-other">
                                    <div class="membership-coupon-other-rays">
                                        ${this.messages.couponInfo.rays_consum}
                                        <span>
                                            ${coupon.limit.costRays}
                                        </span>
                                    </div>
                                    <div class="membership-coupon-other-time">
                                        ${this.messages.couponInfo.time}
                                        <span>
                                            ${this.formatDateTimeForTimezone(coupon.createdAt,this.storeName,true)}
                                        </span>
                                    </div>
                                </div>
                            </div>`;
                        }
                        if(coupon.prizeDetail?.type === 'product_coupon'){
                            rgLotteryContent = `
                            <div class="membership-coupon-dialog-content-success membership-coupon-container product-card-coupon-dialog-success">
                                <div class="membership-coupon-item">
                                    <div class="membership-coupon-top membership-coupon-product-card">
                                        ${coupon?.prizeDetail?.productDetail?.image?
                                        `<div class="product-card-img" >
                                            <img width="100%" src="${coupon?.prizeDetail?.productDetail?.image}" />
                                        </div>`:
                                        `<div class="product-card-img" style="background:#F2FCFF;"></div>`}
                                        <div class="product-card-content">
                                            <a class="product-card-content-title" target="_blank" href="${coupon?.prizeDetail?.productDetail?.link}">${coupon?.prizeDetail?.productDetail?.name || ''}</a>

                                            <div class="product-card-content-sku">${coupon?.prizeDetail?.productDetail?.sku || ''}</div>
                                            <div class="product-card-content-price">
                                                <span class="free">${this.messages.couponInfo.free}</span>
                                                ${coupon?.prizeDetail?.productDetail?.price ? `<span class="underline-price">${ formatter.format(coupon?.prizeDetail?.productDetail?.price) }</span>` :''}
                                            </div>
                                        </div>
                                    </div>
                                    <div class="membership-coupon-item-line-box">
                                        <div class="membership-coupon-item-line"></div>
                                    </div>
                                    <div class="membership-coupon-b">
                                        <div class="membership-coupon-b-top">
                                            <div class="membership-coupon-b-top-content">
                                                <div class="membership-coupon-b-top-content-title">${this.messages.couponInfo.code}:
                                                    <span class="membership-coupon-b-top-content-des">
                                                        ${coupon?.prizeDetail?.value || ''}
                                                    </span>
                                                </div>
                                            </div>
                                            ${coupon?.prizeDetail?.productDetail?.variantId ? `<product-form>
                                                <form class="js-product-form" id="form-id-${coupon?.prizeDetail?.productDetail?.variantId}"  method="post" action="/cart/add" enctype="multipart/form-data" novalidate="novalidate" accept-charset="UTF-8">
                                                    <input type="hidden" name="form_type" value="product"><input type="hidden" name="utf8" value="✓">
                                                    <input type="hidden" name="id" value="${coupon?.prizeDetail?.productDetail?.variantId}" disabled>
                                                    <button name="add" class="membership-coupon-b-top-button membership-coupon-b-top-button-copy btn btn--secondary quick-add-view-btn" data-copy-coupon='${JSON.stringify(coupon)}'>
                                                        ${this.messages.couponInfo.redeem_copy}
                                                    </button>
                                                </form>
                                            </product-form>` : `
                                                <product-form>
                                                    <form class="js-product-form" id="form-id-${coupon?.prizeDetail?.productDetail?.productId}"  method="post" action="/cart/add" enctype="multipart/form-data" novalidate="novalidate" accept-charset="UTF-8">
                                                        <input type="hidden" name="form_type" value="product"><input type="hidden" name="utf8" value="✓">
                                                        <input type="hidden" name="id" value="${coupon?.prizeDetail?.productDetail?.productId}" disabled>
                                                        <button name="add" class="membership-coupon-b-top-button membership-coupon-b-top-button-copy btn btn--secondary quick-add-view-btn" data-copy-coupon='${JSON.stringify(coupon)}'>
                                                            ${this.messages.couponInfo.redeem_copy}
                                                        </button>
                                                    </form>
                                                </product-form>
                                            `}
                                            
                                        </div>
                                        <div class="membership-coupon-b-bottom">
                                            <div class="membership-coupon-b-bottom-time">
                                                ${coupon?.prizeDetail?.validate || ''}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="membership-coupon-b-bottom-rules-container">
                                    <div class="membership-coupon-b-bottom-rules-title">${this.messages.couponInfo.rules}</div>
                                    <div class="membership-coupon-b-bottom-rules-box">
                                        ${membershipCouponRuleHtml}
                                    </div> 
                                </div>
                                <div class="membership-coupon-other">
                                    <div class="membership-coupon-other-rays">
                                        ${this.messages.couponInfo.rays_consum}
                                        <span>
                                            ${coupon.limit.costRays}
                                        </span>
                                    </div>
                                    <div class="membership-coupon-other-time">
                                        ${this.messages.couponInfo.time}
                                        <span>
                                            ${this.formatDateTimeForTimezone(coupon.createdAt,this.storeName,true)}
                                        </span>
                                    </div>
                                </div>
                            </div>
                            `;
                        }
                        if(coupon.prizeDetail?.type === 'none' || coupon.prizeDetail?.type === 'prize_none'){
                            rgLotteryContent = `
                            <div class="membership-coupon-dialog-content-success membership-coupon-container">
                                <div class="membership-coupon-dialog-title-no-prize">${this.messages.couponInfo.no_prize_title || 'Thanks for Participation'}</div>
                                <div class="membership-coupon-other">
                                    <div class="membership-coupon-other-rays">
                                        ${this.messages.couponInfo.rays_consum}
                                        <span>
                                            ${coupon.limit.costRays}
                                        </span>
                                    </div>
                                    <div class="membership-coupon-other-time">
                                        ${this.messages.couponInfo.time}
                                        <span>
                                            ${this.formatDateTimeForTimezone(coupon.createdAt,this.storeName,true)}
                                        </span>
                                    </div>
                                </div>
                            </div>`;
                        }
                        
                        newItemsHtml += `<div class="rg-lottery-item">
                            ${rgLotteryContent}
                        </div>`;
                    }
                    
                    // 插入新数据 - 始终插入到操作按钮之前，保持按钮和哨兵在列表底部
                    if (operationContainer) {
                        operationContainer.insertAdjacentHTML('beforebegin', newItemsHtml);
                    } else if (sentinel) {
                        sentinel.insertAdjacentHTML('beforebegin', newItemsHtml);
                    } else {
                        container.insertAdjacentHTML('beforeend', newItemsHtml);
                    }
                    
                    // 如果没有更多数据，移除哨兵元素
                    if (this.currentPage >= this.totalPages) {
                        if (sentinel) {
                            sentinel.remove();
                        }
                        // 断开 IntersectionObserver
                        if (this.scrollObserver) {
                            this.scrollObserver.disconnect();
                            this.scrollObserver = null;
                        }
                    }
                } else {
                    // 没有更多数据
                    this.totalPages = this.currentPage;
                    const sentinel = container.querySelector('.rg-lottery-loading-sentinel');
                    if (sentinel) {
                        sentinel.remove();
                    }
                    if (this.scrollObserver) {
                        this.scrollObserver.disconnect();
                        this.scrollObserver = null;
                    }
                }
            } catch (error) {
                console.error('加载更多数据失败:', error);
                // 出错时回退页码
                this.currentPage--;
            } finally {
                this.isLoadingMore = false;
            }
        }

        formatDateTimeForTimezone(isoString, countryCode,isZontTime) {
            let date;
    
            // 判断输入时间类型
            if (isoString.includes('T') && isoString.endsWith('Z') && !isZontTime) {
                // 如果是UTC时间（Z结尾），直接使用
                date = new Date(isoString);
            } else {
                // 如果是不带时区的时间，假设为北京时间（UTC+8）
                // 将北京时间转换为UTC时间
                date = new Date(isoString);
                if (!isNaN(date.getTime())) {
                    // 减去8小时转换为UTC
                    date = new Date(date.getTime() - 8 * 60 * 60 * 1000);
                }
            }
            // 完整的国家配置
            const countryConfigs = {
                // 澳大利亚（英语）
                AU: {
                    locale: "en-AU",
                    timeZone: "Australia/Sydney",
                    hour12: true
                },
                // 加拿大（英语区）
                CA: {
                    locale: "en-CA",
                    timeZone: "America/Toronto",
                    hour12: true
                },
                // 德国
                DE: {
                    locale: "de-DE",
                    timeZone: "Europe/Berlin",
                    hour12: false
                },
                // 欧盟通用格式（德国标准）
                EU: {
                    locale: "en-GB",
                    timeZone: "Europe/Berlin",
                    hour12: false
                },
                // 日本
                JP: {
                    locale: "ja-JP",
                    timeZone: "Asia/Tokyo",
                    hour12: false
                },
                UK: {
                    locale: "en-GB",
                    timeZone: "Europe/London",
                    hour12: false  // 英国通常使用24小时制
                },
                // 美国
                US: {
                    locale: "en-US",
                    timeZone: "America/New_York",
                    hour12: true
                },
                // 意大利
                IT: {
                    locale: "it-IT",
                    timeZone: "Europe/Rome",
                    hour12: false
                },
                // 西班牙
                ES: {
                    locale: "es-ES",
                    timeZone: "Europe/Madrid",
                    hour12: false
                },
                // 法国
                FR: {
                    locale: "fr-FR",
                    timeZone: "Europe/Paris",
                    hour12: false
                },
                // 荷兰
                NL: {
                    locale: "nl-NL",
                    timeZone: "Europe/Amsterdam",
                    hour12: false
                },
                RenogyTest: {
                    locale: "en-GB",
                    timeZone: "Europe/London",
                    hour12: false  // 英国通常使用24小时制
                },
            }
            const config = countryConfigs[countryCode];
            
            
            const formatter = new Intl.DateTimeFormat(config.locale, {
                timeZone: config.timeZone,
                year: 'numeric',
                month: '2-digit',
                day: '2-digit',
                hour: '2-digit',
                minute: '2-digit',
                second: '2-digit',
                hour12: config.hour12
            });
            
            // 对于24小时制，我们需要手动格式化为YYYY-MM-DD HH:mm:ss
            if (!config.hour12) {
                const parts = formatter.formatToParts(date);
                const year = parts.find(part => part.type === 'year').value;
                const month = parts.find(part => part.type === 'month').value;
                const day = parts.find(part => part.type === 'day').value;
                const hour = parts.find(part => part.type === 'hour').value;
                const minute = parts.find(part => part.type === 'minute').value;
                const second = parts.find(part => part.type === 'second').value;
                
                return `${year}-${month}-${day} ${hour}:${minute}:${second}`;
            } else {
                // 12小时制处理
                return formatter.format(date);
            }
        }

                


        // 获取所有有效的奖品（非prize_none）
        getValidPrizes() {
            return this.blocks.filter(block => block.settings.prize_id !== 'prize_none');
        }

        initEventListeners() {
            
        }
        // toast
        renderToast(toastIcon,msg,duration = 6000){
            Swal.fire(
                {
                    toast: true,
                    position: 'center',
                    title: msg,
                    customClass: {
                    popup: 'custom-error-toast',
                    container: 'custom-error-toast-container',
                    },
                    iconHtml:toastIcon,
                    showConfirmButton: false,
                    timer: duration,
                    didClose: () => {
                        this.playBtn.removeAttribute("disabled");
                    }
                }
            )
        }
      
        // 优惠券弹窗
        renderCouponDialog(couponInfo){
            // 根据您店铺的GBP设置
            const shopCurrency = window.Shopify.currency.active || 'USD';
            const shopLocale = window.Shopify.locale + '-' + window.Shopify.country || 'en-GB';
            const formatter = new Intl.NumberFormat(shopLocale, {
                style: 'currency',
                currency: shopCurrency
            });
            const currency ='C$' ||  formatter.formatToParts(0).find(p => p.type === 'currency').value;

            let membershipCouponRuleHtml = ``;
            if(couponInfo?.prizeRules?.length > 0) {
                membershipCouponRuleHtml = couponInfo?.prizeRules;
            }
            const membershipCouponDialogSuccess =  this.raysLotteryRGContainer.parentElement.querySelector('.coupon-dialog-success');
            const membershipCouponDialogClone = membershipCouponDialogSuccess.cloneNode(true);
            membershipCouponDialogClone.innerHTML = `

                    <div class="membership-coupon-dialog-title" style="color:rgba(224, 71, 0, 1);">
                        ${this.messages.couponInfo.coupon_title}
                    </div>
                    <div class="membership-coupon-item">
                        <div class="membership-coupon-top">
                            <div class="coupon-l">
                                <div class="coupon-name">
                                    ${couponInfo?.prizeTitle.includes('%') == false ? `<span class="copun-currency">${currency}</span>
                                    <span x-text="coupon.couponAmount">
                                        ${couponInfo?.prizeTitle?.replace(currency, '')?.trim()}
                                    </span>
                                    `:'' }
                                    
                                    ${couponInfo?.prizeTitle.includes('%') ? `
                                        <span x-text="coupon.couponAmount">
                                        ${couponInfo?.prizeTitle?.replace('%', '')?.trim()}
                                    </span><span class="copun-currency">%</span>`:'' }
                                    <span class="off-text">${this.messages.couponInfo.off}</span>
                                </div>
                                <div class="account-coupon-info">
                                     ${couponInfo?.prizeUseLimit || ''}
                                </div>
                            </div>
                        </div>
                        <div class="membership-coupon-b">
                            <div class="membership-coupon-b-top">
                                <div class="membership-coupon-b-top-content">
                                    <div class="membership-coupon-b-top-content-title">${this.messages.couponInfo.code}</div>
                                    <div class="membership-coupon-b-top-content-des">
                                        ${couponInfo.prizeValue || ''}
                                    </div>
                                </div>
                                <div class="membership-coupon-b-top-button membership-coupon-b-top-button-copy" data-coupon-id="${couponInfo.couponTemplateId}" >
                                    ${this.messages.couponInfo.redeem_copy}
                                </div>
                                
                            </div>
                            <div class="membership-coupon-b-line"></div>
                            <div class="membership-coupon-b-bottom">
                                <div class="membership-coupon-b-bottom-time">
                                    ${couponInfo?.prizeValidate || ''}
                                </div>
                            </div>
                            
                        </div>
                    </div>
                    <div class="membership-coupon-b-bottom-rules-container">
                        <div class="membership-coupon-b-bottom-rules-title">${this.messages.couponInfo.rules}</div>
                        <div class="membership-coupon-b-bottom-rules-box">
                            ${membershipCouponRuleHtml}
                        </div> 
                    </div>
            `;
            
            Swal.fire({
                showCloseButton: true,
                showCancelButton: false,
                showConfirmButton: false,
                html: membershipCouponDialogClone,
                closeButtonHtml: this.closeBtnHtml,
                customClass: {
                    container: "membership-coupon-popup-container",
                    popup: "membership-coupon-popup",
                },
            }).then(() => {
                // 弹窗关闭后清理操作
                this.playBtn.removeAttribute("disabled");
            });

            const copyButton = membershipCouponDialogClone.querySelector('.membership-coupon-b-top-button-copy');
            if (copyButton) {
                copyButton.addEventListener('click', () => {
                    // 防止重复点击
                    if (copyButton.classList.contains('copied')) return;
                    
                    navigator.clipboard.writeText(couponInfo.prizeValue).then(() => {
                        // 显示打勾SVG图标
                        const originalText = copyButton.textContent;
                        copyButton.innerHTML = `${originalText}
                            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M13.3332 4L5.99984 11.3333L2.6665 8" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                        `;
                        copyButton.classList.add('copied');
                        
                        // 3秒后恢复原始状态
                        setTimeout(() => {
                            copyButton.innerHTML = originalText;
                            copyButton.classList.remove('copied');
                        }, 3000);
                    }).catch(err => {
                        console.error('Failed to copy coupon code: ', err);
                    });
                });
            }
        }

        // 礼品卡弹窗
        renderGiftCardCouponDialog(couponInfo){
            // 根据您店铺的GBP设置
            const shopCurrency = window.Shopify.currency.active || 'USD';
            const shopLocale = window.Shopify.locale + '-' + window.Shopify.country || 'en-GB';
            const formatter = new Intl.NumberFormat(shopLocale, {
                style: 'currency',
                currency: shopCurrency
            });
            const currency ='C$' || formatter.formatToParts(0).find(p => p.type === 'currency').value;
            
            let membershipCouponRuleHtml = ``;
            if(couponInfo?.prizeRules?.length > 0) {
                membershipCouponRuleHtml = couponInfo?.prizeRules;
            }
            
            const membershipCouponDialogSuccess =  this.raysLotteryRGContainer.parentElement.querySelector('.gift-card-coupon-dialog-success')
            const membershipCouponDialogClone = membershipCouponDialogSuccess.cloneNode(true);
            membershipCouponDialogClone.innerHTML= `
                    <div class="membership-coupon-dialog-title" style="color:rgba(224, 71, 0, 1);">
                        ${this.messages.couponInfo.gift_card_title}
                    </div>
                    <div class="membership-coupon-item">
                        <div class="membership-coupon-top">
                            <div class="coupon-l">
                                <div class="coupon-name">
                                    <span class="copun-currency">${currency}</span>
                                    <span x-text="coupon.couponAmount">
                                        ${couponInfo?.prizeValue}
                                    </span>
                                    <span class="off-text">${this.messages.couponInfo.off}</span>
                                </div>
                                <div class="account-coupon-info">
                                     ${couponInfo?.prizeUseLimit || ''}
                                </div>
                            </div>
                        </div>
                        <div class="membership-coupon-b">
                            <div class="membership-coupon-b-top">
                                <div class="membership-coupon-b-top-content">
                                    <div class="membership-coupon-b-top-content-title">${this.messages.couponInfo.gift_card_code}</div>
                                    <div class="membership-coupon-b-top-content-des">
                                        ${this.messages.couponInfo.check_email}
                                    </div>
                                </div>
                            </div>
                            <div class="membership-coupon-b-line"></div>
                            <div class="membership-coupon-b-bottom">
                                <div class="membership-coupon-b-bottom-time">
                                    ${couponInfo?.prizeValidate || ''}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="membership-coupon-b-bottom-rules-container">
                        <div class="membership-coupon-b-bottom-rules-title">${this.messages.couponInfo.rules}</div>
                        <div class="membership-coupon-b-bottom-rules-box">
                            ${membershipCouponRuleHtml}
                        </div> 
                    </div>
            `;
            Swal.fire({
                showCloseButton: true,
                showCancelButton: false,
                showConfirmButton: false,
                html: membershipCouponDialogClone,
                closeButtonHtml: this.closeBtnHtml,
                customClass: {
                    container: "membership-coupon-popup-container",
                    popup: "membership-coupon-popup",
                },
            }).then(() => {
                // 弹窗关闭后清理操作
                this.playBtn.removeAttribute("disabled");
            });
        }
        
        // 商品优惠券弹窗
        renderProductCardCouponDialog(couponInfo){
            // 根据您店铺的GBP设置
            const shopCurrency = window.Shopify.currency.active || 'USD';
            const shopLocale = window.Shopify.locale + '-' + window.Shopify.country || 'en-GB';
            const formatter = new Intl.NumberFormat(shopLocale, {
                style: 'currency',
                currency: shopCurrency
            });
            
            
            let membershipCouponRuleHtml = ``;
            if(couponInfo?.prizeRules?.length > 0) {
                membershipCouponRuleHtml = couponInfo?.prizeRules;
            }
            const membershipCouponDialogSuccess =  this.raysLotteryRGContainer.parentElement.querySelector('.product-card-coupon-dialog-success')
            const membershipCouponDialogClone = membershipCouponDialogSuccess.cloneNode(true);
            membershipCouponDialogClone.innerHTML = `
                    <div class="membership-coupon-dialog-title" style="color:rgba(224, 71, 0, 1);">
                        ${this.messages.couponInfo.product_coupon_title}
                    </div>
                    <div class="membership-coupon-item">
                        <div class="membership-coupon-top membership-coupon-product-card">
                            ${couponInfo?.prizeProductDetail?.image?
                            `<div class="product-card-img" >
                                <img width="100%" src="${couponInfo?.prizeProductDetail?.image}" />
                            </div>`:
                            `<div class="product-card-img" style="background:#F2FCFF;"></div>`}
                            <div class="product-card-content">
                                <a class="product-card-content-title" target="_blank" href="${couponInfo?.prizeProductDetail?.link || ''}">${couponInfo?.prizeProductDetail?.name || ''}</a>
                                <div class="product-card-content-sku">${couponInfo?.prizeProductDetail?.sku || ''}</div>
                                <div class="product-card-content-price">
                                    <span class="free">${this.messages.couponInfo.free}</span>
                                    ${couponInfo?.prizeProductDetail?.price? `<span class="underline-price">${formatter.format(couponInfo?.prizeProductDetail?.price) }</span>` : ''}
                                </div>
                            </div>
                        </div>
                        <div class="membership-coupon-item-line-box">
                            <div class="membership-coupon-item-line"></div>
                        </div>
                        <div class="membership-coupon-b" style="gap:0;">
                            <div class="membership-coupon-b-top">
                                <div class="membership-coupon-b-top-content">
                                    <div class="membership-coupon-b-top-content-title">${this.messages.couponInfo.code}:
                                        <span class="membership-coupon-b-top-content-des">
                                            ${couponInfo.prizeValue || ''}
                                        </span>
                                    </div>
                                </div>
                                ${couponInfo.prizeProductDetail?.variantId? `<product-form>
                                    <form class="js-product-form" id="form-id-${couponInfo.prizeProductDetail?.variantId}"  method="post" action="/cart/add" enctype="multipart/form-data" novalidate="novalidate" accept-charset="UTF-8">
                                        <input type="hidden" name="form_type" value="product"><input type="hidden" name="utf8" value="✓">
                                        <input type="hidden" name="id" value="${couponInfo.prizeProductDetail?.variantId}" disabled>
                                        <button name="add" class="membership-coupon-b-top-button membership-coupon-b-top-button-copy btn btn--secondary quick-add-view-btn" data-coupon-id="${couponInfo.couponTemplateId}" >
                                            ${this.messages.couponInfo.redeem_copy}
                                        </button>
                                    </form>
                                </product-form>`:`
                                    <product-form>
                                        <form class="js-product-form" id="form-id-${couponInfo.prizeProductDetail?.productId}"  method="post" action="/cart/add" enctype="multipart/form-data" novalidate="novalidate" accept-charset="UTF-8">
                                            <input type="hidden" name="form_type" value="product"><input type="hidden" name="utf8" value="✓">
                                            <input type="hidden" name="id" value="${couponInfo.prizeProductDetail?.productId}" disabled>
                                            <button name="add" class="membership-coupon-b-top-button membership-coupon-b-top-button-copy btn btn--secondary quick-add-view-btn" data-coupon-id="${couponInfo.couponTemplateId}" >
                                                ${this.messages.couponInfo.redeem_copy}
                                            </button>
                                        </form>
                                    </product-form>
                                `} 
                                
                            </div>
                            <div class="membership-coupon-b-bottom">
                                <div class="membership-coupon-b-bottom-time">
                                    ${couponInfo?.prizeValidate || ''}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="membership-coupon-b-bottom-rules-container">
                        <div class="membership-coupon-b-bottom-rules-title">${this.messages.couponInfo.rules}</div>
                        <div class="membership-coupon-b-bottom-rules-box">
                            ${membershipCouponRuleHtml}
                        </div> 
                    </div>
                `
            Swal.fire({
                showCloseButton: true,
                showCancelButton: false,
                showConfirmButton: false,
                html: membershipCouponDialogClone,
                closeButtonHtml: this.closeBtnHtml,
                customClass: {
                    container: "membership-coupon-popup-container",
                    popup: "membership-coupon-popup",
                },
            }).then(() => {
                // 弹窗关闭后清理操作
                this.playBtn.removeAttribute("disabled");
            });
            const copyButton = membershipCouponDialogClone.querySelector('.membership-coupon-b-top-button-copy');
            if (copyButton) {
                copyButton.addEventListener('click', () => {
                    let maxTime= 0
                    let copyButtonTimer = setInterval(() => {
                        if(copyButton.classList.contains('is-success')){
                            Swal.close();
                            clearInterval(copyButtonTimer);
                        }
                        maxTime += 50;
                    }, 10);
                    if(maxTime >= 3000){
                        Swal.close();
                        clearInterval(copyButtonTimer);
                    }
                    // 防止重复点击
                    if (copyButton.classList.contains('copied')) return;
                    
                    navigator.clipboard.writeText(couponInfo.prizeValue).then(() => {
                        // 显示打勾SVG图标
                        const originalText = copyButton.textContent;
                        copyButton.classList.add('copied');
                        
                        // 3秒后恢复原始状态
                        setTimeout(() => {
                            copyButton.innerHTML = originalText;
                            copyButton.classList.remove('copied');
                        }, 3000);
                    }).catch(err => {
                        console.error('Failed to copy coupon code: ', err);
                    });
                });
            }
        }
       
        couponExpiresHandler(coupon) {
            const createDate = coupon.createDate;
            const couponExpires = coupon.couponExpires || coupon.giftCardExpires;
            let startDate = new Date(createDate);
            let couponExpiresNew = Number(couponExpires);
        
            if (isNaN(startDate.getTime())) {
                throw new Error('无效的开始时间格式');
            }
            
            const tenDaysInMs = couponExpiresNew * 24 * 60 * 60 * 1000;
            const resultDate = new Date(startDate.getTime() + tenDaysInMs);
            const resultDateYear = resultDate.getFullYear();
            const resultDateMonth = (resultDate.getMonth() + 1) > 9 ? `${resultDate.getMonth() + 1}` : `0${resultDate.getMonth() + 1}`;
            const resultDateDay = resultDate.getDate() > 9 ? `${resultDate.getDate()}` : `0${resultDate.getDate()}`;
            return resultDateYear + '-' + resultDateMonth + '-' + resultDateDay ;
        }

        // learn more rules
        learnMoreRules() {
            const learnMoreRulesHtml = this.raysLotteryRGContainer.querySelector(".rg-lottery-learn-more-rules-text").innerHTML;
            Swal.fire({
                html: learnMoreRulesHtml,
                padding: "0",
                position: "",
                showCloseButton: true,
                showCancelButton: false,
                showConfirmButton: false,
                closeButtonHtml:this.closeBtnHtml,
                customClass: {
                container: "pdp-learnMore-dialog-box",
                popup: "pdp-learnMore-dialog-popup pdp-learnMore-dialog-popup-other",
                },
            });
            
        }

        async submitForm() {
            // 清除之前的动画状态
            this.clearLotteryAnimation();
            let raysLotteryCount = Number(this.getLotteryCookie(this.activity)?.raysLotteryCount||0)
           
            // 获取表单中的邮箱
            // const emailInput = this.form.querySelector('input[type="email"]');
            const email = this.customerEmail || '';
            
            // 在移动端设备上，滚动到奖品区域
            const isMobile = window.matchMedia("(max-width: 768px)").matches;
            if (isMobile) {
                const prizeContainer = this.raysLotteryRGContainer.querySelector('.prize-product-container');
                if (prizeContainer) {
                    prizeContainer.scrollIntoView({ behavior: 'smooth', block: 'center' });
                }
            }
            
            // 第一阶段：开始无限循环动画
            const animationPromise = this.startLotteryAnimation(100);
            const url = this.apiUrl+`/api/lottery/draw-rays${this.lang ? '?lang='+this.lang :'' }`;
            const _data = { 
                email, 
                storeName: this.storeName,
                activity: this.activity,
                limit: {
                    day: 1,
                    count: window.raysLotteryBlocksData.settings.active_lottery_draw_time,
                    memberCheck:true,
                    costRays:window.raysLotteryBlocksData.settings.lottery_entry_requirements == 'ALL' ? 0 : window.raysLotteryBlocksData.settings.lottery_vip_points
                }
            };
            try {
                const res = await fetch(url, {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                        "X-Token": this.accessToken
                    },
                    body: JSON.stringify(_data),
                });
                
                const data = await res.json();
                
                // 判断返回的code值
                if (data.code == 200) { 
                    raysLotteryCount += 1;
                    this.playBtn.removeAttribute("disabled");
                    this.setLotteryCookie(this.activity, raysLotteryCount,1);
                    if (data.data.success) {
                        // 获取中奖的 prizeId
                        const targetPrizeId = data.data.prizeId || data.data.prize_id || 'prize_1';
                        
                        // 第二阶段：设置目标，让动画连续地停在目标位置
                        this.setLotteryTarget(targetPrizeId);
                        
                        // 等待动画完成
                        await animationPromise;
                        // 动画结束后显示对应弹窗
                        if(data.data.prizeType === 'coupon_code'){
                            this.renderCouponDialog(data.data);
                        }
                        // 礼品卡弹窗
                        if(data.data.prizeType === 'gift_card'){
                            this.renderGiftCardCouponDialog(data.data);
                            this.confirmSubmitGiftCard(targetPrizeId)
                        }
                        // 商品卡优惠券弹窗
                        if(data.data.prizeType === 'product_coupon'){
                            this.renderProductCardCouponDialog(data.data);
                        }
                        this.showViewPrizeButton();
                    } else {
                        // 未中奖，随机选择一个未中奖产品
                        this.setLotteryTarget('prize_none', true);
                        await animationPromise;
                        this.notLucky();
                    }
                    
                    await this.getMerberData();
                } else { 
                    // 请求失败，停止动画
                    this.clearLotteryAnimation();
                    this.renderToast(this.toastTipsIcon, data.msg || "Request failed", 6000);
                }

            } catch(error) {
                console.error("Fetch error:", error);
                // 出错时停止动画
                this.clearLotteryAnimation();
                this.renderToast(this.toastErrorIcon, "Network error", 6000);
            }
        }

        // 存储抽奖次数
        setLotteryCookie(activityId, raysLotteryCount, days = 1) {
            if (!activityId) return false;
            
            const data = {
                activityId: activityId,
                raysLotteryCount: raysLotteryCount,
                lastUpdated: new Date().toISOString(),
                createdAt: new Date().toDateString() // 添加创建时间，用于判断是否在同一天
            };
            
            const cookieName = `activity_lottery_${activityId}`; // 修改存储键名为活动相关
            const existingData = this.getLotteryCookie(activityId);
            
            let expires;
            
            if (existingData && existingData.createdAt === new Date().toDateString()) {
                // 同一天内，使用固定过期时间（当天23:59:59）
                const now = new Date();
                const endOfDay = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 23, 59, 59);
                expires = "expires=" + endOfDay.toUTCString();
            } else {
                // 新的一天或新活动，设置新的过期时间
                const date = new Date();
                date.setDate(date.getDate() + days);
                expires = "expires=" + date.toUTCString();
            }
            
            document.cookie = `${cookieName}=${encodeURIComponent(JSON.stringify(data))}; ${expires}; path=/; SameSite=Lax`;
            
            return true;
        }

        getLotteryCookie(activityId) {
            if (!activityId) return null;
            
            const cookieName = `activity_lottery_${activityId}`; // 修改存储键名为活动相关
            const nameEQ = cookieName + "=";
            const cookies = document.cookie.split(';');
            
            for (let i = 0; i < cookies.length; i++) {
                let cookie = cookies[i];
                while (cookie.charAt(0) === ' ') {
                    cookie = cookie.substring(1);
                }
                if (cookie.indexOf(nameEQ) === 0) {
                    try {
                        const cookieValue = decodeURIComponent(cookie.substring(nameEQ.length));
                        return JSON.parse(cookieValue);
                    } catch (e) {
                        console.error('解析Cookie失败:', e);
                        return null;
                    }
                }
            }
            return null;
        }

        // 获取用户中奖记录
        async getPrizeHistory(page = 1, pageSize = 10, append = false){
            const url = this.apiUrl+`/api/lottery/user-records${this.lang ? '?lang='+this.lang :'' }`;
            const _data = { 
                email:this.customerEmail, 
                storeName: this.storeName,
                activity: this.activity,
                page: page,
                pageSize: pageSize
             };
            try {
                const res = await fetch(url, {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                        "X-Token": this.accessToken
                    },
                    body: JSON.stringify(_data),
                });
                
                const data = await res.json();
                
                // 判断返回的code值
                if (data.code == 200) { 
                    const newRecords = data.data.records || [];
                    if (append) {
                        // 追加数据
                        this.raysLotteryUserList = [...this.raysLotteryUserList, ...newRecords];
                    } else {
                        // 替换数据
                        this.raysLotteryUserList = newRecords;
                    }
                    // 返回分页信息
                    return {
                        records: newRecords,
                        totalPages: data.data.totalPages || 1,
                        currentPage: page
                    };
                }
                return { records: [], totalPages: 1, currentPage: page };
            } catch(error) {
                console.error("Fetch error:", error);
                return { records: [], totalPages: 1, currentPage: page };
            }
        }
        async confirmSubmitGiftCard(targetPrizeId) { 
            const url = this.apiUrl+`/api/lottery/claim${this.lang ? '?lang='+this.lang :'' }`;
            const _data = { email:this.customerEmail, storeName: this.storeName,activity: this.activity, prizeId:targetPrizeId,findsql:true };
            
            try {
                const res = await fetch(url, {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify(_data),
                });
            } catch(error) {
                console.error("Fetch error:", error);
            }
        }
        getSite(){
            const currentDomain = window.location.hostname;
            switch (currentDomain) {
            case "uk.renogy.com":
                return {site:"UK",apiUrl:`https://shopify-api.renogy.com`};
            case "www.renogy.com":
                return {site:"US",apiUrl:`https://shopify-api.renogy.com`};
            case "ca.renogy.com":
                return {site:"CA",apiUrl:`https://shopify-api.renogy.com`};
             case "eu.renogy.com":
                return {site:"EU",apiUrl:`https://shopify-api.renogy.com`};
            case "au.renogy.com":
                return {site:"AU",apiUrl:`https://shopify-api.renogy.com`};
            case "de.renogy.com":
                return {site:"DE",apiUrl:`https://shopify-api.renogy.com`};
            case "jp.renogy.com":
                return {site:"JP",apiUrl:`https://shopify-api.renogy.com`};
            case "fr.renogy.com":
                return {site:"FR",apiUrl:`https://shopify-api.renogy.com`};
            case "nl.renogy.com":
                return {site:"NL",apiUrl:`https://shopify-api.renogy.com`};
            case "it.renogy.com":
                return {site:"IT",apiUrl:`https://shopify-api.renogy.com`};
            case "es.renogy.com":
                return {site:"ES",apiUrl:`https://shopify-api.renogy.com`};
            default:
                return {site:"RenogyTest",apiUrl:`https://d-shopify-api.renogy.cn`};
            }
        }

        // 二次确认提交表单
        confirmSubmitForm(couponInfo,targetPrizeId,email){
            const confirmHtml = `
                <div class="membership-coupon-confirm-container membership-coupon-dialog-content-success membership-coupon-container">
                    <div class="membership-coupon-dialog-title" style="color:rgba(224, 71, 0, 1);">
                        <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28" fill="none">
                            <rect width="28" height="28" transform="matrix(-1 0 0 1 28 0)" fill="white"/>
                            <path d="M6.6982 14.8717C6.6513 14.7828 6.52399 14.7828 6.47709 14.8717L6.00503 15.7664C5.98694 15.8007 5.95398 15.8246 5.91579 15.8312L4.91898 16.0037C4.81995 16.0208 4.78061 16.1419 4.85066 16.214L5.55571 16.9394C5.58272 16.9672 5.59532 17.006 5.5898 17.0443L5.4458 18.0456C5.43149 18.1451 5.53449 18.22 5.62468 18.1756L6.53249 17.7292C6.56727 17.7121 6.60802 17.7121 6.6428 17.7292L7.55061 18.1756C7.6408 18.22 7.7438 18.1451 7.72949 18.0456L7.58549 17.0443C7.57998 17.006 7.59257 16.9672 7.61958 16.9394L8.32464 16.214C8.39469 16.1419 8.35534 16.0208 8.25631 16.0037L7.25951 15.8312C7.22131 15.8246 7.18835 15.8007 7.17026 15.7664L6.6982 14.8717Z" fill="#FCC161"/>
                            <path d="M12.8684 1.62619C12.7833 1.57266 12.673 1.63631 12.6769 1.73675L12.7154 2.74763C12.7169 2.78636 12.7003 2.82358 12.6706 2.8484L11.8935 3.49617C11.8163 3.56053 11.8428 3.68505 11.9395 3.71245L12.9128 3.98817C12.9501 3.99873 12.9804 4.026 12.9948 4.06198L13.3707 5.00114C13.4081 5.09445 13.5347 5.10776 13.5906 5.02426L14.1536 4.18378C14.1752 4.15158 14.2105 4.13121 14.2492 4.12863L15.2585 4.06129C15.3588 4.0546 15.4106 3.9383 15.3485 3.8593L14.7231 3.06413C14.6992 3.03367 14.6907 2.99381 14.7002 2.95623L14.9481 1.97546C14.9727 1.87801 14.8781 1.79283 14.7837 1.82751L13.8342 2.17654C13.7979 2.18991 13.7573 2.18566 13.7245 2.16501L12.8684 1.62619Z" fill="#FCC161"/>
                            <path d="M2.6806 1.89682C2.58028 1.90309 2.52802 2.01918 2.58983 2.09844L3.21191 2.89618C3.23574 2.92674 3.24405 2.96663 3.2344 3.00417L2.98248 3.98392C2.95745 4.08126 3.05171 4.16683 3.14619 4.13254L4.09711 3.78743C4.13355 3.7742 4.17405 3.77863 4.20677 3.79941L5.06072 4.34175C5.14556 4.39564 5.25608 4.33244 5.25266 4.23199L5.21829 3.22096C5.21697 3.18222 5.2337 3.14506 5.26357 3.12037L6.04325 2.47581C6.12072 2.41177 6.09476 2.28713 5.99817 2.25934L5.026 1.97961C4.98876 1.96889 4.95859 1.9415 4.94433 1.90546L4.57225 0.964757C4.53529 0.871295 4.40873 0.857466 4.35245 0.940738L3.78599 1.77888C3.76429 1.811 3.72892 1.83123 3.69024 1.83365L2.6806 1.89682Z" fill="#FCC161"/>
                            <path d="M4.58458 8.24892C5.15806 8.10862 6.01026 7.97754 6.92376 8.89105C7.83727 9.80455 7.31458 10.9789 8.15547 11.8198C8.99635 12.6607 9.737 12.2265 10.1 12.0673" stroke="#E04700" stroke-width="1.6" stroke-linecap="round"/>
                            <path d="M10.5499 6.06709C10.1081 6.06713 9.7499 6.42535 9.74993 6.86716C9.74998 7.30897 10.1082 7.66715 10.55 7.66712C10.6932 7.6671 10.8962 7.69943 11.0519 7.7768C11.1866 7.84373 11.2369 7.91347 11.2564 8.01142C11.3046 8.254 11.2964 8.38016 11.2873 8.43827C11.2792 8.49037 11.2664 8.52423 11.2247 8.61058C11.1908 8.68106 11.0661 8.91079 11.0417 9.1992C11.0155 9.50934 11.1025 9.79524 11.2355 10.065C11.5346 10.6711 11.9994 10.9908 12.4633 11.128C12.8905 11.2542 13.2822 11.2139 13.434 11.1997C13.8738 11.1583 14.1969 10.7682 14.1556 10.3284C14.1142 9.88848 13.7241 9.56536 13.2842 9.60668C13.1409 9.62015 13.0224 9.6248 12.9168 9.59359C12.8715 9.58019 12.834 9.56117 12.8003 9.53365C12.7676 9.50689 12.7196 9.45675 12.6704 9.35709C12.6605 9.33687 12.6515 9.31442 12.6583 9.29293C12.6623 9.28046 12.6684 9.27064 12.6704 9.26641C12.7301 9.14258 12.8228 8.97574 12.8681 8.68513C12.9126 8.40053 12.9015 8.08055 12.8256 7.69927C12.6855 6.9951 12.2199 6.57061 11.7638 6.34395C11.3287 6.12776 10.8658 6.06706 10.5499 6.06709Z" fill="#E04700"/>
                            <circle cx="0.75" cy="0.75" r="0.75" transform="matrix(-0.707107 0.707107 0.707107 0.707107 15.4973 5.875)" fill="#E04700"/>
                            <circle cx="0.75" cy="0.75" r="0.75" transform="matrix(-0.707107 0.707107 0.707107 0.707107 3.68848 11.0352)" fill="#E04700"/>
                            <path d="M18.2763 9.06294L23.5282 22.4844C23.7824 23.1341 23.1413 23.7752 22.4917 23.521L9.07018 18.2691C8.53293 18.0588 8.38807 17.3663 8.79601 16.9584L16.9656 8.78877C17.3736 8.38083 18.0661 8.52568 18.2763 9.06294Z" fill="white"/>
                            <path d="M22.4921 23.5214C23.1415 23.7753 23.7824 23.1344 23.5286 22.4849L19.7313 12.7823L12.7894 19.7242L22.4921 23.5214ZM8.79604 16.9586C8.38817 17.3666 8.53364 18.059 9.07087 18.2692L10.7565 18.9287L18.9358 10.7493L18.2764 9.06373C18.0662 8.52649 17.3737 8.38099 16.9657 8.78889L8.79604 16.9586Z" fill="#E04700"/>
                        </svg> 
                        ${this.messages.couponInfo.gift_card_title_1}
                    </div>
                    <div class="membership-coupon-dialog-content">
                        <div class="membership-coupon-dialog-content-title">Please confirm the email, you will receive GiftCard Code in it.</div>
                        <form method="post" id="subscript-email-confirm" accept-charset="UTF-8" class="form subscript-form" data-lottery-rg-form="">
                            <div class="form__field">
                                <div class="input-with-button input-with-button--md-up">
                                    <input type="email" class="input w-full focus-inset" id="subscript-email-confirm-input" name="sub-email" value="${email}" placeholder="Enter your email..." autocomplete="email" aria-required="true" required="">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28" fill="none">
                                        <rect width="28" height="28" />
                                        <path d="M9.29692 14.3575L9.22924 16.9704L11.8422 16.9028L17.111 11.634L14.5657 9.08868L9.29692 14.3575ZM13.0873 18.4862C12.8337 18.7397 12.4928 18.8869 12.1343 18.8963L8.64919 18.9868C7.84759 19.0077 7.19197 18.3521 7.21288 17.5505L7.30403 14.066C7.31339 13.7075 7.45992 13.366 7.71352 13.1124L13.5755 7.25048C14.1222 6.70374 15.0092 6.70375 15.5559 7.25048L18.9499 10.6445C19.4965 11.1912 19.4959 12.0775 18.9492 12.6242L13.0873 18.4862Z" fill="#1C1C1C"/>
                                        <path d="M15.9802 7.67437L18.5255 10.2197L19.6566 9.08858L17.1113 6.54327L15.9802 7.67437ZM18.8079 12.7657L18.7458 12.8168C18.6126 12.9049 18.4384 12.9049 18.3052 12.8168L18.2431 12.7657L13.4349 7.95748L13.3831 7.89465C13.2952 7.76146 13.295 7.58719 13.3831 7.45409L13.4342 7.39194L16.8281 3.99796C16.9648 3.86128 17.1763 3.84365 17.3315 3.94617L17.3944 3.99796L22.2026 8.80615L22.2537 8.8683C22.3564 9.02359 22.3387 9.23492 22.2019 9.3717L18.8079 12.7657Z" fill="#1C1C1C"/>
                                        <path d="M23 22C23.5523 22 24 22.4477 24 23C24 23.5523 23.5523 24 23 24H5C4.44772 24 4 23.5523 4 23C4 22.4477 4.44772 22 5 22H23Z" fill="#1C1C1C"/>
                                    </svg>
                                </div>
                                <button class="btn btn--primary  subscript-button-confirm">Confirm</button>
                            </div>
                        </form>
                    </div>
                </div>
            `;
            Swal.fire({
                showCloseButton: true,
                showCancelButton: false,
                showConfirmButton: false,
                html: confirmHtml,
                closeButtonHtml: this.closeBtnHtml,
                customClass: {
                    container: "membership-coupon-popup-container",
                    popup: "membership-coupon-popup",
                },
                didOpen:()=>{
                    // 二次弹窗确认
                    const confirmButton = document.querySelector('.subscript-button-confirm');
                    if (confirmButton) {
                        // 监听按钮点击事件
                        confirmButton.addEventListener('click', (e)=>{
                            e.preventDefault();
                            // 获取弹窗内邮箱输入框的值
                            const emailInput = document.getElementById('subscript-email-confirm-input');
                            const emailValue = emailInput ? emailInput.value : '';
                            this.confirmSubmitGiftCard(targetPrizeId,email,emailValue)
                            this.renderGiftCardCouponDialog(couponInfo);
                        });
                    }
                }
                
            }).then((result) => {
                
            })
        }

        // 未中奖
        notLucky(){
            let raysLotteryCount = Number(this.getLotteryCookie(this.activity)?.raysLotteryCount || 0)
            const notLuckyHtml = `
                <div class="membership-coupon-confirm-container membership-coupon-dialog-content-success membership-coupon-container">
                    <div class="membership-coupon-dialog-title">
                        <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28" fill="none">
                            <rect width="28" height="28" fill="white"/>
                            <circle cx="14" cy="14" r="10" fill="#FCC061"/>
                            <ellipse cx="11.4" cy="12.2004" rx="1.4" ry="1.8" fill="#1C1C1C"/>
                            <ellipse cx="16.6" cy="12.2004" rx="1.4" ry="1.8" fill="#1C1C1C"/>
                            <line x1="11.8" y1="17.1992" x2="16.2" y2="17.1992" stroke="#1C1C1C" stroke-width="2" stroke-linecap="round"/>
                        </svg>
                        Sorry, No Luck This Time
                    </div>
                    ${raysLotteryCount >= window.raysLotteryBlocksData.settings.active_lottery_draw_time ? '' :`<div class="membership-coupon-dialog-content">
                        <div class="membership-coupon-dialog-content-title" style="text-align:left;">Try more times to win a prize!</div>
                    </div>`}
                    
                </div>
            `;
            Swal.fire({
                showCloseButton: true,
                showCancelButton: false,
                showConfirmButton: false,
                html: notLuckyHtml,
                closeButtonHtml: this.closeBtnHtml,
                customClass: {
                    container: "membership-coupon-popup-container",
                    popup: "membership-coupon-popup",
                }, 
            }) 
        }
        renderEmailError(){}


        checkFormValidity(){
            const termsCheckbox = document.querySelector('.rg-lottery-subscribe-container .terms-checkbox')
            // const emailInput = document.querySelector('.rg-lottery-subscribe-container .input-with-button input')
            // const emailVal = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(emailInput.value.trim());
            // if (!emailVal) {
            //     this.renderToast(this.toastErrorIcon, this.messages.invalid_email, 5000);
            //     return false;
            // }
            if (!termsCheckbox.checked) {
                // Add shake effect to checkbox
                termsCheckbox.classList.add('shake');
                setTimeout(() => {
                    termsCheckbox.classList.remove('shake');
                }, 500);
                return false;
            }else{
                return true;
            }
        }

        /**
         * 开始抽奖动画（无限循环）
         * @param {number} duration - 每次点亮的时间间隔(ms)，默认100ms
         */
        startLotteryAnimation(duration = 100) {
            // 初始化动画状态
            this.lotteryAnimation = {
                isRunning: true,
                hasTarget: false,
                targetPrizeId: null,
                currentStep: 0,
                duration: duration,
                minLoopsBeforeStop: 2, // 收到目标后至少再转2圈
                prizeItems: Array.from(
                    this.raysLotteryRGContainer.querySelectorAll('.prize-product-item:not(.prize-product-item-center)')
                ),
                sequence: [0, 1, 2, 4, 7, 6, 5, 3], // 九宫格顺时针顺序
                currentActiveItem: null,
                resolveCallback: null
            };

            if (this.lotteryAnimation.prizeItems.length === 0) {
                return Promise.resolve();
            }

            // 返回一个Promise，当动画完全停止时resolve
            this.lotteryAnimation.promise = new Promise((resolve) => {
                this.lotteryAnimation.resolveCallback = resolve;
            });

            // 开始动画循环
            this._runLotteryAnimationStep();

            return this.lotteryAnimation.promise;
        }
        // 未登录渲染的内容
        initNoLoginContent(){
            this.noLogin = true;
            this.playBtn.innerHTML = window.raysLotteryBlocksData.settings.no_login_play_btn_text;
            const loginBtn = document.querySelector('.rg-layout-container .rg-lottery-content-left-login');
            const viewPrizeBtn = document.querySelector('.rg-layout-container .rg-lottery-content-left-view-prize');
            this.playBtn.addEventListener('click', ()=>{
                return;
            });
            loginBtn.style.display = 'block';
            viewPrizeBtn.style.display = 'none';
            if(this.playBtn.getAttribute('login-href')){
                this.playBtn.addEventListener('click', () => { 
                    window.location.href = this.playBtn.getAttribute('login-href');
                });
            }
        }

        /**
         * 设置抽奖目标，动画会连续地停在目标位置
         * @param {string} targetPrizeId - 中奖的 data-prize-product-item-id，如果是'prize_none'会随机选择一个未中奖产品
         * @param {boolean} isNoLuck - 是否是未中奖（用于随机选择未中奖产品）
         */
        setLotteryTarget(targetPrizeId, isNoLuck = false) {
            if (!this.lotteryAnimation || !this.lotteryAnimation.isRunning) {
                console.warn('动画未运行，请先调用 startLotteryAnimation()');
                return;
            }

            let targetIndex = -1;
            
            // 如果是未中奖，随机选择一个 prize_none 产品
            if (isNoLuck) {
                const noPrizeItems = [];
                this.lotteryAnimation.prizeItems.forEach((item, index) => {
                    const prizeId = item.getAttribute('data-prize-product-item-id');
                    if (prizeId === 'prize_none') {
                        noPrizeItems.push(index);
                    }
                });
                
                if (noPrizeItems.length > 0) {
                    // 随机选择一个未中奖产品
                    const randomIndex = Math.floor(Math.random() * noPrizeItems.length);
                    targetIndex = noPrizeItems[randomIndex];
                } else {
                    // 没有未中奖产品，不设置目标，直接停止动画
                    this.lotteryAnimation.isRunning = false;
                    this.lotteryAnimation.hasTarget = false;
                    // 清除所有active状态
                    this.lotteryAnimation.prizeItems.forEach(item => {
                        item.classList.remove('active-prize-product-item');
                    });
                    // 等待一段时间后resolve
                    setTimeout(() => {
                        if (this.lotteryAnimation.resolveCallback) {
                            this.lotteryAnimation.resolveCallback();
                        }
                    }, 300);
                    return;
                }
            } else {
                // 找到指定的目标奖品
                this.lotteryAnimation.prizeItems.forEach((item, index) => {
                    const prizeId = item.getAttribute('data-prize-product-item-id');
                    if (prizeId === targetPrizeId) {
                        targetIndex = index;
                    }
                });

                // 如果没找到目标，直接结束动画，不停留在任何奖品上
                if (targetIndex === -1) {
                    // 停止动画
                    this.lotteryAnimation.isRunning = false;
                    this.lotteryAnimation.hasTarget = false;
                    // 清除所有active状态
                    this.lotteryAnimation.prizeItems.forEach(item => {
                        item.classList.remove('active-prize-product-item');
                    });
                    // 立即resolve Promise，让后续弹窗动作继续执行
                    setTimeout(() => {
                        if (this.lotteryAnimation.resolveCallback) {
                            this.lotteryAnimation.resolveCallback();
                        }
                    }, 300);
                    return;
                }
            }

            // 计算需要额外转动的步数
            const currentSequenceIndex = this.lotteryAnimation.currentStep % this.lotteryAnimation.sequence.length;
            const targetSequenceIndex = this.lotteryAnimation.sequence.indexOf(targetIndex);
            
            // 至少再转 minLoopsBeforeStop 圈后停在目标位置
            const stepsInOneLoop = this.lotteryAnimation.sequence.length;
            const minSteps = this.lotteryAnimation.minLoopsBeforeStop * stepsInOneLoop;
            
            // 计算从当前位置到目标位置需要的步数
            let stepsToTarget = targetSequenceIndex - currentSequenceIndex;
            if (stepsToTarget <= 0) {
                stepsToTarget += stepsInOneLoop;
            }
            
            // 总步数 = 最小圈数 + 到目标的步数
            // totalSteps-1 对应的位置应该是目标位置，所以这里要确保计算正确
            const totalStepsToStop = minSteps + stepsToTarget;
            
            this.lotteryAnimation.hasTarget = true;
            this.lotteryAnimation.targetPrizeId = targetPrizeId;
            this.lotteryAnimation.targetIndex = targetIndex;
            this.lotteryAnimation.targetSequenceIndex = targetSequenceIndex;
            this.lotteryAnimation.stepsWhenTargetSet = this.lotteryAnimation.currentStep;
            this.lotteryAnimation.totalSteps = this.lotteryAnimation.currentStep + totalStepsToStop;
            
        }

        /**
         * 动画循环的单步执行
         * @private
         */
        _runLotteryAnimationStep() {
            if (!this.lotteryAnimation.isRunning) {
                return;
            }

            const anim = this.lotteryAnimation;

            // 移除上一个active状态
            if (anim.currentActiveItem) {
                anim.currentActiveItem.classList.remove('active-prize-product-item');
            }

            // 计算当前应该点亮哪个位置
            const sequenceIndex = anim.currentStep % anim.sequence.length;
            const prizeIndex = anim.sequence[sequenceIndex];
            anim.currentActiveItem = anim.prizeItems[prizeIndex];
            
            if (anim.currentActiveItem) {
                anim.currentActiveItem.classList.add('active-prize-product-item');
            }


            // 步数+1，准备下一步
            anim.currentStep++;

            // 检查是否已经到达目标位置（步数+1后检查）
            if (anim.hasTarget && anim.currentStep > anim.totalSteps) {
                // 动画结束，当前显示的就是目标位置，保持其active状态
                anim.isRunning = false;
                
                
                // 等待一段时间，让用户看到最终结果，然后再resolve Promise
                setTimeout(() => {
                    if (anim.resolveCallback) {
                        anim.resolveCallback();
                    }
                }, 500); // 停留500ms让用户看到中奖结果
                
                return;
            }

            // 计算下一步的延迟时间（减速效果）
            let nextDuration = anim.duration;
            if (anim.hasTarget) {
                const stepsRemaining = anim.totalSteps - anim.currentStep + 1;
                const slowdownSteps = 8;
                if (stepsRemaining <= slowdownSteps) {
                    // 最后几步逐渐减速
                    nextDuration = anim.duration * (1 + (slowdownSteps - stepsRemaining) * 0.3);
                }
            }

            // 继续下一步
            setTimeout(() => this._runLotteryAnimationStep(), nextDuration);
        }

        /**
         * 停止并清除所有奖品的active状态
         */
        clearLotteryAnimation() {
            if (this.lotteryAnimation) {
                this.lotteryAnimation.isRunning = false;
            }
            const prizeItems = this.raysLotteryRGContainer.querySelectorAll('.prize-product-item');
            prizeItems.forEach(item => {
                item.classList.remove('active-prize-product-item');
            });
        }

        // 刷新 token：只刷新一次，并排队等待
        refreshAccessToken() {
            if (this.isRefreshing) {
                return this.refreshPromise;
            }

            // 没有 refreshToken 时不调用刷新接口，直接走未登录兜底
            if (!this.refreshToken) {
                this.pendingRequests = [];
                this.initNoLoginContent();
                return Promise.reject(new Error("Refresh token not found"));
            }

            this.isRefreshing = true;

            this.refreshPromise = new Promise((resolve, reject) => {
                fetch(this.API_DOMAIN + "/api/v1/account/pc/do_refresh", {
                    method: "POST",
                    headers: {
                        "X-Token": this.accessToken,
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify({
                        refreshToken: this.refreshToken,
                    }),
                })
                    .then(response => {
                        if (!response.ok) throw new Error("Refresh failed");
                        return response.json();
                    })
                    .then(resp => {
                        // 使用 js-cookie 设置 cookie（需要确保页面已加载 Cookies）
                        if (typeof Cookies !== 'undefined') {
                            Cookies.set(this.ACCESS_TOKEN_KEY, resp.data.accessToken, {
                                domain: ".renogy.com",
                                expires: 370,
                                sameSite: "strict",
                            });
                            Cookies.set(this.REFRESH_TOKEN_KEY, resp.data.refreshToken, {
                                domain: ".renogy.com",
                                expires: 370,
                                sameSite: "strict",
                            });
                        }
                        if(resp.data){
                            // 更新实例中的 token
                            this.accessToken = resp.data.accessToken;
                            this.refreshToken = resp.data.refreshToken;
                            this.noLogin = false;
                        }else{
                            this.initNoLoginContent();
                        }
                        resolve(resp);

                        // 执行所有挂起请求
                        for (let i = 0; i < this.pendingRequests.length; i++) {
                            this.pendingRequests[i]();
                        }
                        this.pendingRequests = [];
                    })
                    .catch(err => {
                        this.initNoLoginContent();
                        this.pendingRequests = [];
                        reject(err);
                    })
                    .finally(() => {
                        this.isRefreshing = false;
                        this.refreshPromise = null;
                    });
            });

            return this.refreshPromise;
        }

        // 通用的 API 请求方法
        _request(apiPath, options = {}, isRetry = false, isFullUrl = false) {
            const apiUrl = isFullUrl ? apiPath : `/mem-service/api/v1/bigcommerce${apiPath}`;
            
            options.headers = options.headers || {};
            options.headers['Content-Type'] = 'application/json';
            options.headers['X-Token'] = this.accessToken;
            
            const url = isFullUrl ? apiUrl : `${this.API_DOMAIN}${apiUrl}`;
            
            return fetch(url, options)
                .then(response => {
                    if (response.status === 401 && !isRetry) {
                        // Token 过期，排队等待刷新完成
                        return new Promise((resolve, reject) => {
                            this.pendingRequests.push(() => {
                                this._request(apiPath, options, true, isFullUrl).then(resolve).catch(reject);
                            });

                            this.refreshAccessToken().catch(reject); // 刷新失败则中断所有请求
                        });
                    }else{
                        this.noLogin = false;
                    }

                    if (!response.ok) {
                        return response.text().then(text => {
                            throw new Error(`HTTP Error ${response.status}: ${text}`);
                        });
                    }

                    return response.json();
                })
                .catch(error => {
                    throw error;
                });
        }
        async getMerberData() {
            // 获取用户权益信息 - 基于customer-account.js中的getInfo方法
            return this._request('/get_user_information?storeId=' + this.storeId)
            .then(resp => {
                if (resp.code === "000000") {
                    this.merberData = resp.data;
                    this.customerPoints = resp.data.userBonusPoints;

                    const raysRightText = this.raysLotteryRGContainer.querySelector('.rays-right-text');
                    raysRightText.innerHTML = this.customerPoints;
                    if(this.customerPoints < window.raysLotteryBlocksData.settings.lottery_vip_points){
                        if(this.headSubtitle){
                            this.headSubtitle.style.display = 'block'
                            this.headSubtitle.innerHTML = window.raysLotteryBlocksData.settings.no_points_tips
                        }
                    }
                }
                return resp;
            }).catch(error=>{ throw error; }
                
            );
        }

        // 获取所有奖品库存
        async getPrizeStock() { 
            const url = this.apiUrl+`/api/lottery/check-prize-stock${this.lang ? '?lang='+this.lang :'' }`;

            const _data = { 
                email:this.customerEmail,
                storeName: this.storeName,
                activity: this.activity,
            };

            try {
                const res = await fetch(url, {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify(_data),
                });
                
                const data = await res.json();
                
                // 判断返回的code值
                if (data.code == 200) { 
                    this.allOutOfStock = data.data?.allOutOfStock || false;
                }
            } catch(error) {
                console.error("Fetch error:", error);
            }
        }
        getCookie(name) {
            const value = `; ${document.cookie}`;
            const parts = value.split(`; ${name}=`);
            if (parts.length === 2) {
                return parts.pop().split(';').shift();
            }
            return null;
        }
        
        getAccessToken() {
            return this.accessToken;
        }

        getRefreshToken() {
            return this.refreshToken;
        }
    }

    const _RaysLotteryRG = new RaysLotteryRG();
    _RaysLotteryRG.init();
    
}
